import React from "react";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import {
    BACK, BANK_ACCOUNT_SUMMARY_TABLE_CELLS,
    CARRIER_TABLE_CELLS, CREDIT_CARD_BALANCES_SUMMARY_TABLE_CELLS,
    CUSTOMER_TABLE_CELLS,
    EDIT_LEDGER,
    FTL_CARRIER_TABLE_CELLS,
    LEDGER_ENTRIES_CELLS,
    LEDGER_PAYABLE_ENTRIES_CELLS,
    LEDGER_TABLE_CELLS,
    LEDGERS_PAGES,
    MARKETPLACE_ENTRIES_CELLS, MARKETPLACE_MAPPING,
    MARKETPLACE_TABLE_CELLS, OUTSTANDING_CHEQUES_SUMMARY_TABLE_CELLS, SALES_TABLE_CELLS,
    SAVE, STOCK_IN_HAND_TABLE_CELLS, SUM_RULE_OPTIONS,
    SUPPLIER_TABLE_CELLS,
} from './constants';
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import SaveIcon from "@material-ui/icons/Save";
import {
    Box,
    Dialog, DialogActions,
    DialogContent, DialogContentText,
    DialogTitle,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select
} from '@mui/material';
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { Button, Checkbox, Chip, TableCell, TextField } from '@material-ui/core';
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import AddCircleIcon from "@material-ui/icons/AddCircle";
import MenuIcon from '@mui/icons-material/Menu';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import InputAdornment from "@material-ui/core/InputAdornment";
import RefreshIcon from '@mui/icons-material/Refresh';
import {Layout} from "../../global/Table/TablePageHelpers/LayoutObject";
import TablePage from "../../global/Table/TablePage";
import EditIcon from "@material-ui/icons/Edit";
import { format } from 'date-fns';
import Tooltip from "@material-ui/core/Tooltip";
import LedgerEntryTableRow from "./LedgerEntryTableRow";
import CloseIcon from "@material-ui/icons/Close";
import { HourglassEmptyTwoTone } from '@material-ui/icons';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import CarrierEntryTableRow from './summary/CarrierEntryTableRow';
import FTLEntryTableRow from './summary/FTLEntryTableRow';
import SupplierEntryTableRow from './summary/SupplierEntryTableRow';
import StockEntryTableRow from './summary/StockEntryTableRow';
import MarketplaceEntryTableRow from './summary/MarketplaceEntryTableRow';
import Utils from '../../Utils/Utils';
import CustomerEntryTableRow from './summary/CustomerEntryTableRow';
import SettingsIcon from '@material-ui/icons/Settings';
import DeleteIcon from '@material-ui/icons/Delete';
import SalesEntryTableRow from './summary/SalesEntryTableRow';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import BankAccountEntryTableRow from './summary/BankAccountEntryTableRow';
import OutstandingChequesEntryTableRow from './summary/OutstandingChequesEntryTableRow';
import CreditCardBalancesEntryTableRow from "./summary/CreditCardBalancesEntryTableRow";
import LedgerAuditPreviewDialog from './preview/LedgerAuditPreviewDialog';
import { buildLedgerDiff, LEDGER_SECTIONS } from './preview/ledgerDiff';


class EditLedger extends React.Component {
    constructor(props) {
        super(props);

        try {
            const saved = localStorage.getItem('LedgerEntriesTable');
            if (saved) {
                const parsed = JSON.parse(saved);
                parsed.page = 0;
                localStorage.setItem('LedgerEntriesTable', JSON.stringify(parsed));
            }
        } catch (e) {
        }

        this.state = {
            templates: this.props.ledger.ledgerEntries || [],
            anchorEl: null,
            activeIndex: null,
            draggedIndex: null,
            isEditEntries: false,
            deleteId: "",
            isDeleted: false,
            listingIdBeingEdited: '',
            isEdit: false,
            isEditPayable: false,
            isShowPayable: false,
            hideFilterBox : false,
            isDialogOpen: false,
            currentNote: '',
            selectedIndex: null,
            isRefresh: false,
            carrierSummary: this.props.carrierSummary || [],
            supplierSummary: this.props.supplierSummary || [],
            customerSummary: this.props.customerSummary || [],
            bankAccountSummary: this.props.bankAccountSummary || [],
            outstandingChequesSummary: this.props.outstandingChequesSummary || [],
            ftlSummary: this.props.ftlSummary || [],
            stockSummary: this.props.stockSummary || [],
            marketplaceSummary: this.props.marketplaceSummary || [],
            creditCardBalancesSummary: this.props.creditCardBalancesSummary || [],
            isShowMarketplaceDetails: false,
            isEditMarketplace: false,
            marketplaceEntries: [],
            selectedMarketplace: null,
            isDialogFetch: false,
            salesSummary: this.props.salesSummary || [],
            isMarketplaceDialog: false,
            currentMarketplaceNote: '',
            selectedMarketplaceIndex: null,
            isSummaryNotesDialog: false,
            currentSummaryNote: '',
            summarySaveCallback: null,
            isViewMarketplaceNoteDialog: false,
            currentViewMarketplaceNote: '',
            isAuditPreviewOpen: false,
            previewEntries: null,
            previewOldTemplates: null,
        };
    }

    setHideFilterBox = (isHide) =>{
        this.setState({hideFilterBox : isHide})
    }

    componentDidMount() {

        if(this.props.ledger.name === "Accounts Payable" ||
          this.props.ledger.name === "Accounts Receivables" ||
          this.props.ledger.name === "Cash" ||
          this.props.ledger.name === "Sales" ||
          this.props.ledger.name === "Cost of Sales"){
            this.setState({isShowPayable: true})
        }


        if (this.props.ledger?.ledgerEntries && this.props.ledger.ledgerEntries.length > 0) {
            this.setState({
                templates: [...this.props.ledger.ledgerEntries],
            });
        }
        const data = {
            ledgerId: this.props.ledger.ledgerId,
            year: this.props.selectedYear,
            currency: this.props.selectedCurrency,
            isRefresh: this.state.isRefresh
        }
        this.props.ledgerEntries(data)
    }

    fetchLedgerEntries = () => {
        const data = {
            ledgerId: this.props.ledger.ledgerId,
            year: this.props.selectedYear,
            currency: this.props.selectedCurrency
        }
        this.props.fetchTransactionsLedger(data)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // When the ledger being viewed changes (e.g. drilling into a sub-ledger
        // or coming back to the parent), reset the view and re-fetch its entries.
        if (prevProps.ledger?.ledgerId !== this.props.ledger?.ledgerId) {
            const name = this.props.ledger?.name;
            const isPayable = name === "Accounts Payable" ||
              name === "Accounts Receivables" ||
              name === "Cash" ||
              name === "Sales" ||
              name === "Cost of Sales";
            this.setState({
                isShowPayable: isPayable,
                isShowMarketplaceDetails: false,
                isEditMarketplace: false,
                isEditPayable: false,
                isEditEntries: false,
                listingIdBeingEdited: '',
                templates: [],
            });
            const data = {
                ledgerId: this.props.ledger.ledgerId,
                year: this.props.selectedYear,
                currency: this.props.selectedCurrency,
                isRefresh: false
            };
            this.props.ledgerEntries(data);
        }

        if (prevProps.fetchTransactions !== this.props.fetchTransactions) {
            const { ledgerEntries } = this.props.fetchTransactions;
            if (ledgerEntries && Array.isArray(ledgerEntries)) {
                // Normalize transactions

                const flattenedTemplates = ledgerEntries.map(entry => {
                    if (entry.entries) {
                        return entry.entries; // Handle nested entries
                    }
                    return entry; // Handle top-level entries
                }).flat(); // Flatten any nested arrays


                this.setState({
                    templates: flattenedTemplates,
                }, this.updateBalances);
            }else{
                // Normalize transactions
                const flattenedTemplates = this.props.fetchTransactions.map(entry => {
                    if (entry.entries) {
                        return entry.entries; // Handle nested entries
                    }
                    return entry; // Handle top-level entries
                }).flat(); // Flatten any nested arrays


                this.setState({
                    templates: flattenedTemplates,
                }, this.updateBalances);

            }
        }


        if (prevProps.stockSummary !== this.props.stockSummary) {
            this.setState({
                stockSummary : this.props.stockSummary
            })
        }


         if (prevProps.outstandingChequesSummary !== this.props.outstandingChequesSummary) {
            this.setState({
                outstandingChequesSummary : this.props.outstandingChequesSummary
            })
        }

        if (prevProps.creditCardBalancesSummary !== this.props.creditCardBalancesSummary) {
            this.setState({
                creditCardBalancesSummary : this.props.creditCardBalancesSummary
            })
        }

         if (prevProps.bankAccountSummary !== this.props.bankAccountSummary) {
            this.setState({
                bankAccountSummary : this.props.bankAccountSummary
            })
        }

        if (prevProps.customerSummary !== this.props.customerSummary) {
            this.setState({
                customerSummary : this.props.customerSummary
            })
        }

        if (prevProps.salesSummary !== this.props.salesSummary) {
            this.setState({
                salesSummary : this.props.salesSummary
            })
        }

        if (prevProps.supplierSummary !== this.props.supplierSummary) {
            this.setState({
                supplierSummary : this.props.supplierSummary
            })
        }
        if (prevProps.ftlSummary !== this.props.ftlSummary) {
            this.setState({
                ftlSummary : this.props.ftlSummary
            })
        }

        if (prevProps.carrierSummary !== this.props.carrierSummary) {
            this.setState({
                carrierSummary : this.props.carrierSummary
            })
        }

        if (prevProps.marketplaceSummary !== this.props.marketplaceSummary) {
            this.setState({
                marketplaceSummary : this.props.marketplaceSummary
            })

            // When viewing marketplace details, refresh the inner entries from the latest data
            if (this.state.isShowMarketplaceDetails && this.state.selectedMarketplace) {
                const refreshedMarketplace = (this.props.marketplaceSummary || []).find(
                  m => m.name === this.state.selectedMarketplace.name
                );
                if (refreshedMarketplace && refreshedMarketplace.entries) {
                    this.setState({
                        selectedMarketplace: refreshedMarketplace,
                        marketplaceEntries: [...refreshedMarketplace.entries],
                    });
                }
            }
        }
    }


    onDragStart = (index) => {
        this.setState({draggedIndex: index});
    };

    onDragMarketplaceOver = (index) => {
        const {draggedIndex, marketplaceEntries} = this.state;
        if (draggedIndex === index) return;

        const updatedTemplates = [...marketplaceEntries];
        const [draggedItem] = updatedTemplates.splice(draggedIndex, 1);
        updatedTemplates.splice(index, 0, draggedItem);

        this.setState({
            marketplaceEntries: updatedTemplates,
            draggedIndex: index,
        }, this.updateMarketplaceBalances);
    }

    onDragOver = (index) => {
        const { draggedIndex, templates } = this.state;

        if (draggedIndex === index) return;

        const draggedItem = templates[draggedIndex];
        const targetItem = templates[index];

        const isDraggingOpening = draggedItem.description === 'Opening Balance';
        const isTargetOpening = targetItem.description === 'Opening Balance';

        if (isDraggingOpening || isTargetOpening) {
            return;
        }

        const updatedTemplates = [...templates];
        const [removed] = updatedTemplates.splice(draggedIndex, 1);
        updatedTemplates.splice(index, 0, removed);

        this.setState({
            templates: updatedTemplates,
            draggedIndex: index,
        }, this.updateBalances);
    }


    onDragEnd = () => {
        this.setState({draggedIndex: null})
    }

    getContextualMenuItems = () => {
        const { selectedCurrency } = this.props;
        const { isEditEntries, isEditPayable, isShowPayable, isShowMarketplaceDetails } = this.state;
        const menuItems = [];


        // Dynamic menu items based on isShowPayable and isEditPayable


        if (isShowMarketplaceDetails) {

            if (this.state.isEditMarketplace) {
                menuItems.push({
                    title: 'Back',
                    icon: <KeyboardBackspaceIcon />,
                    onClick: () => {
                        this.setState({isEditMarketplace: false});
                    },
                })

                menuItems.push({
                    title: 'Save',
                    icon: <SaveIcon />,
                    onClick: () => this.handleMarketplaceEntriesSave(),
                });
            }else{
                menuItems.push({
                    title: 'Back',
                    icon: <KeyboardBackspaceIcon />,
                    onClick: () => {
                        this.setState({ isShowMarketplaceDetails: false })
                    },
                });

                menuItems.push({
                    title: 'Edit Entries',
                    icon: <EditIcon />,
                    onClick: () => this.setState({ isEditMarketplace: true }),
                });

            }
            return menuItems;
        }


        if (isShowPayable ) {
                if (selectedCurrency === "Consolidated CAD"){
                    menuItems.push({
                        title: 'Back',
                        icon: <KeyboardBackspaceIcon />,
                        onClick: () => {
                            this.props.goBack();
                        },
                    },
                      {
                          title: 'Download as CSV',
                          icon: <FileDownloadIcon />,
                          onClick: () => {
                              this.handlePredefinedLedgerExport()
                          }
                      })
                }else{
                    menuItems.push({
                        title: 'Back',
                        icon: <KeyboardBackspaceIcon />,
                        onClick: () => {
                            this.props.goBack();
                        },
                    })
                    menuItems.push(
                        isEditPayable
                            ? {
                                title: 'Cancel Editing',
                                icon: <CloseIcon />,
                                onClick: () => {
                                    this.setHideFilterBox(false);
                                    this.setState({ isEditPayable: false });


                                    this.setState({ listingIdBeingEdited: null }, () => {
                                        if (this.state.carrierSummary && this.state.carrierSummary.length > 0) {
                                            const newEntry = this.state.carrierSummary.filter(entry => entry.id !== '' && entry.id !== null);
                                            this.setState({ carrierSummary: newEntry });
                                        }
                                    });

                                    this.setState({ listingIdBeingEdited: null }, () => {
                                        if (this.state.supplierSummary && this.state.supplierSummary.length > 0) {
                                            const newEntry = this.state.supplierSummary.filter(entry => entry.id !== '' && entry.id !== null);
                                            this.setState({ supplierSummary: newEntry });
                                        }
                                    });

                                    this.setState({ listingIdBeingEdited: null }, () => {
                                        if (this.state.ftlSummary && this.state.ftlSummary.length > 0) {
                                            const newEntry = this.state.ftlSummary.filter(entry => entry.id !== '' && entry.id !== null);
                                            this.setState({ ftlSummary: newEntry });
                                        }
                                    });

                                    this.setState({ listingIdBeingEdited: null }, () => {
                                        if (this.state.templates && this.state.templates.length > 0) {
                                            const newEntry = this.state.templates.filter(entry => entry.transactionId !== '' && entry.transactionId !== null);
                                            this.setState({ templates: newEntry });
                                        }
                                    });

                                     this.setState({ listingIdBeingEdited: null }, () => {
                                        if (this.state.creditCardBalancesSummary && this.state.creditCardBalancesSummary.length > 0) {
                                            const newEntry = this.state.creditCardBalancesSummary.filter(entry => entry.id !== '' && entry.id !== null);
                                            this.setState({ creditCardBalancesSummary: newEntry });
                                        }
                                    });

                                     this.setState({ listingIdBeingEdited: null }, () => {
                                        if (this.state.outstandingChequesSummary && this.state.outstandingChequesSummary.length > 0) {
                                            const newEntry = this.state.outstandingChequesSummary.filter(entry => entry.id !== '' && entry.id !== null);
                                            this.setState({ outstandingChequesSummary: newEntry });
                                        }
                                    });

                                   this.setState({ listingIdBeingEdited: null }, () => {
                                        if (this.state.bankAccountSummary && this.state.bankAccountSummary.length > 0) {
                                            const newEntry = this.state.bankAccountSummary.filter(entry => entry.id !== '' && entry.id !== null);
                                            this.setState({ bankAccountSummary: newEntry });
                                        }
                                    });

                                    this.setState({ listingIdBeingEdited: null }, () => {
                                        if (this.state.salesSummary && this.state.salesSummary.length > 0) {
                                            const newEntry = this.state.salesSummary.filter(entry => entry.id !== '' && entry.id !== null);
                                            this.setState({ salesSummary: newEntry });
                                        }
                                    });

                                     this.setState({ listingIdBeingEdited: null }, () => {
                                        if (this.state.marketplaceSummary && this.state.marketplaceSummary.length > 0) {
                                            const newEntry = this.state.marketplaceSummary.filter(entry => entry.id !== '' && entry.id !== null);
                                            this.setState({ marketplaceSummary: newEntry });
                                        }
                                    });

                                    this.setState({ listingIdBeingEdited: null }, () => {
                                        if (this.state.customerSummary && this.state.customerSummary.length > 0) {
                                            const newEntry = this.state.customerSummary.filter(entry => entry.id !== '' && entry.id !== null);
                                            this.setState({ customerSummary: newEntry });
                                        }
                                    });

                                },
                            }
                            : {
                                title: 'Edit Entry',
                                icon: <EditIcon />,
                                onClick: () => {
                                    this.setState({ isEditPayable: true });
                                },
                            }
                    );

                    {(this.props.ledger.name === "Cost of Sales" ||
                      this.props.ledger.name === "Accounts Receivables" ||
                      this.props.ledger.name === "Cash" ||
                      this.props.ledger.name === "Sales" ||
                      this.props.ledger.name === "Accounts Payable") &&
                         menuItems.push({
                            title: 'Refresh',
                            icon: <RefreshIcon />,
                            onClick: () => {
                                this.handleOpenAuditPreview()
                            },
                        },
                           {
                               title: 'Download as CSV',
                               icon: <FileDownloadIcon />,
                               onClick: () => {
                                   this.handlePredefinedLedgerExport()
                               }
                           })
                    }
                }
        }
        else{
            if (selectedCurrency === "Consolidated CAD"){
                menuItems.push({
                    title: 'Back',
                    icon: <KeyboardBackspaceIcon />,
                    onClick: () => {
                        this.props.goBack();
                    }
                },
                  {
                    title: 'Download as CSV',
                    icon: <FileDownloadIcon />,
                      onClick: () => {
                          this.handleExport()
                      }
                  }
                  )
            }else {
                if (isEditEntries) {
                    menuItems.push({
                        title: 'Back',
                        icon: <KeyboardBackspaceIcon />,
                        onClick: () => {
                            this.fetchLedgerEntries();
                            this.setState({ isEditEntries: false });
                        },
                    })

                    menuItems.push({
                        title: 'Save',
                        icon: <SaveIcon />,
                        disabled: this.isSaveDisabled(),
                        onClick: this.isSaveDisabled() ? null : this.handleSave,
                    });
                }
                else {
                    menuItems.push({
                        title: 'Back',
                        icon: <KeyboardBackspaceIcon />,
                        onClick: () => {
                            this.props.goBack();
                        },
                    })

                    menuItems.push({
                        title: 'Edit Entries',
                        icon: <EditIcon />,
                        onClick: () => this.setState({ isEditEntries: true }),
                    });

                    menuItems.push( {
                        title: 'Settings',
                          icon: <SettingsIcon />,
                          onClick: () => {
                             this.props.setCurrentPage(LEDGERS_PAGES.FORM, this.props.ledger)
                         }
                    })

                    menuItems.push({
                        title: 'Refresh',
                        icon: <RefreshIcon />,
                        onClick: () => {
                            this.handleRefresh()
                        },
                    },
                    {
                     title: 'Download as CSV',
                     icon: <FileDownloadIcon />,
                      onClick: () => {
                        this.handleExport()
                    }
                    }
                    );
                }
            }

        }

        //loading indicator
        if (this.props.loadingData) {
            menuItems.push({
                title: "Loading data...",
                icon: <HourglassEmptyTwoTone />,
                onClick: () => null,
                disabled: true
            })
        }


        // Combine back button with menu items
        return [...menuItems];
    };

    handlePredefinedLedgerExport = () => {
        let csvContent = "";

        const ledgerName = this.state.isShowMarketplaceDetails
          ? `Ledger - ${this.props.ledger.name} (${MARKETPLACE_MAPPING[this.state.selectedMarketplace.name] ?? this.state.selectedMarketplace.name})`
          : `Ledger - ${this.props.ledger.name}`;

        if (this.props.ledger.name === "Accounts Payable") {
            const { creditCardBalancesSummary, carrierSummary, ftlSummary, supplierSummary, templates } = this.state;

           // Generate CSV content for Credit Card Balances
            const headerBankSummary = CREDIT_CARD_BALANCES_SUMMARY_TABLE_CELLS.map(field => field.label).join(',');
            const rowsCreditCardBalances = creditCardBalancesSummary
              .filter(row => row.name !== "Total")
              .map(row =>
                CREDIT_CARD_BALANCES_SUMMARY_TABLE_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value;
                    return value;
                }).join(',')
              );

            // Calculate total for Carrier
            const totalCreditCardAccount = rowsCreditCardBalances.reduce((acc, row) => {
                const [name,totalBalance] = row.split(',');
                return acc + parseFloat(totalBalance || 0);
            }, 0);

            const totalCreditBankRow = `Total,${totalCreditCardAccount.toFixed(2)}`;


            // Generate CSV content for Carrier
            const headerCarrier = CARRIER_TABLE_CELLS.map(field => field.label).join(',');
            const rowsCarrier = carrierSummary
              .filter(row => row.carrierName !== "Total")
              .map(row =>
                CARRIER_TABLE_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                    return value;
                }).join(',')
            );

            // Calculate total for Carrier
            const totalCarrierAmount = rowsCarrier.reduce((acc, row) => {
                const [carrier, amount] = row.split(',');
                return acc + parseFloat(amount || 0);
            }, 0);
            const totalCarrierRow = `Total,${totalCarrierAmount.toFixed(2)}`;


            // Generate CSV content for FTL
            const headerFTL = FTL_CARRIER_TABLE_CELLS.map(field => field.label).join(',');
            const rowsFTL = ftlSummary
              .filter(row => row.carrierName !== "Total")
              .map(row =>
                FTL_CARRIER_TABLE_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                    return value;
                }).join(',')
            );

            // Calculate total for FTL
            const totalFTLAmount = rowsFTL.reduce((acc, row) => {
                const [carrier, amount] = row.split(',');
                return acc + parseFloat(amount || 0);
            }, 0);

            const totalFTLRow = `Total,${totalFTLAmount.toFixed(2)}`;

            // Generate CSV content for Supplier
            const headerSupplier = SUPPLIER_TABLE_CELLS.map(field => field.label).join(',');
            const rowsSupplier = supplierSummary
              .filter(row => row.supplierName !== "Total")
              .map(row =>
            SUPPLIER_TABLE_CELLS.map(field => {
                let value = row[field.id] ?? '';
                value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                return value;
            }).join(',')

            );

            // Calculate total for Supplier
            const totalSupplierAmount = rowsSupplier.reduce((acc, row) => {
                const [supplier, amount] = row.split(',');
                return acc + parseFloat(amount || 0);
            }, 0);
            const totalSupplierRow = `Total,${totalSupplierAmount.toFixed(2)}`;


            // Generate CSV content for Other
            const headerOther = LEDGER_PAYABLE_ENTRIES_CELLS.map(field => field.label).join(',');
            const rowsOther = templates
              .filter(row => row.description !== "Accounts Payable")
              .map(row =>
                LEDGER_PAYABLE_ENTRIES_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                    return value;
                }).join(',')
              );

            // Calculate total for Supplier
            const totalOtherAmount = rowsOther.reduce((acc, row) => {
                const [description, credit] = row.split(',');
                return acc + parseFloat(credit || 0);
            }, 0);
            const totalOtherRow = `Total,${totalOtherAmount.toFixed(2)}`;


            const total = totalCreditCardAccount + totalCarrierAmount + totalFTLAmount + totalSupplierAmount + totalOtherAmount;
            const accountsPayableTotal = `Accounts Payable Total,${total.toFixed(2)}`;

            // Combine headers, rows, and totals, ensuring "Total" is last
            csvContent = [
                 headerBankSummary,
                ...rowsCreditCardBalances,
                totalCreditBankRow,
                '', // Empty line between tables
                headerCarrier,
                ...rowsCarrier,
                totalCarrierRow,
                '', // Empty line between tables
                headerFTL,
                ...rowsFTL,
                totalFTLRow,
                '', // Empty line between tables
                headerSupplier,
                ...rowsSupplier,
                totalSupplierRow,
                '', // Empty line between tables
                headerOther,
                ...rowsOther,
                totalOtherRow,
                '', // Empty line between tables
                accountsPayableTotal
            ].join('\n');
        }
        else if (this.props.ledger.name === "Cost of Sales") {
            const { stockSummary, carrierSummary, ftlSummary, supplierSummary, templates } = this.state;

            // Generate CSV content for Carrier
            const headerStock = STOCK_IN_HAND_TABLE_CELLS.map(field => field.label).join(',');
            const rowsStock = stockSummary
              .filter(row => row.name !== "Total")
              .map(row =>
                STOCK_IN_HAND_TABLE_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                    return value;
                }).join(',')
              );

            // Calculate total for Carrier
            const totalStockAmount = rowsStock.reduce((acc, row) => {
                const [name, balance] = row.split(',');
                return acc + parseFloat(balance || 0);
            }, 0);
            const totalStockRow = `Total,${totalStockAmount.toFixed(2)}`;



            // Generate CSV content for Carrier
            const headerCarrier = CARRIER_TABLE_CELLS.map(field => field.label).join(',');
            const rowsCarrier = carrierSummary
              .filter(row => row.carrierName !== "Total")
              .map(row =>
                CARRIER_TABLE_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                    return value;
                }).join(',')
              );

            // Calculate total for Carrier
            const totalCarrierAmount = rowsCarrier.reduce((acc, row) => {
                const [carrier, amount] = row.split(',');
                return acc + parseFloat(amount || 0);
            }, 0);
            const totalCarrierRow = `Total,${totalCarrierAmount.toFixed(2)}`;


            // Generate CSV content for FTL
            const headerFTL = FTL_CARRIER_TABLE_CELLS.map(field => field.label).join(',');
            const rowsFTL = ftlSummary
              .filter(row => row.carrierName !== "Total")
              .map(row =>
                FTL_CARRIER_TABLE_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                    return value;
                }).join(',')
              );

            // Calculate total for FTL
            const totalFTLAmount = rowsFTL.reduce((acc, row) => {
                const [carrier, amount] = row.split(',');
                return acc + parseFloat(amount || 0);
            }, 0);

            const totalFTLRow = `Total,${totalFTLAmount.toFixed(2)}`;

            // Generate CSV content for Supplier
            const headerSupplier = SUPPLIER_TABLE_CELLS.map(field => field.label).join(',');
            const rowsSupplier = supplierSummary
              .filter(row => row.supplierName !== "Total")
              .map(row =>
                SUPPLIER_TABLE_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                    return value;
                }).join(',')
              );

            // Calculate total for Supplier
            const totalSupplierAmount = rowsSupplier.reduce((acc, row) => {
                const [supplier, amount] = row.split(',');
                return acc + parseFloat(amount || 0);
            }, 0);
            const totalSupplierRow = `Total,${totalSupplierAmount.toFixed(2)}`;


            // Generate CSV content for Other
            const headerOther = LEDGER_PAYABLE_ENTRIES_CELLS.map(field => field.label).join(',');
            const rowsOther = templates
              .filter(row => row.description !== "Cost of Sales")
              .map(row =>
                LEDGER_PAYABLE_ENTRIES_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                    return value;
                }).join(',')
              );

            // Calculate total for Supplier
            const totalOtherAmount = rowsOther.reduce((acc, row) => {
                const [description, credit] = row.split(',');
                return acc + parseFloat(credit || 0);
            }, 0);
            const totalOtherRow = `Total,${totalOtherAmount.toFixed(2)}`;


            const total = totalStockAmount + totalCarrierAmount + totalFTLAmount + totalSupplierAmount + totalOtherAmount;
            const costSalesTotal = `Cost of Sales Total,${total.toFixed(2)}`;

            // Combine headers, rows, and totals, ensuring "Total" is last
            csvContent = [
                headerStock,
                ...rowsStock,
                '', // Empty line between tables
                headerCarrier,
                ...rowsCarrier,
                totalCarrierRow,
                '', // Empty line between tables
                headerFTL,
                ...rowsFTL,
                totalFTLRow,
                '', // Empty line between tables
                headerSupplier,
                ...rowsSupplier,
                totalSupplierRow,
                '', // Empty line between tables
                headerOther,
                ...rowsOther,
                totalOtherRow,
                '', // Empty line between tables
                costSalesTotal
            ].join('\n');
        }
        else if (this.props.ledger.name === "Sales") {
            const { salesSummary, customerSummary, templates } = this.state;

            // Generate CSV content for Carrier
            const headerSales = SALES_TABLE_CELLS.map(field => field.label).join(',');
            const rowsSales = salesSummary
              .filter(row => row.name !== "Total")
              .map(row =>
                SALES_TABLE_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                    return value;
                }).join(',')
              );

            const mappedMarketplaces = rowsSales.map(row => {
                const [key, amount] = row.split(',');
                return `${MARKETPLACE_MAPPING[key] || key},${parseFloat(amount).toFixed(2)}`;
            });


            // Calculate total for Carrier
            const totalSalesAmount = mappedMarketplaces.reduce((acc, row) => {
                const [name, totalBalance] = row.split(',');
                return acc + parseFloat(totalBalance || 0);
            }, 0);
            const totalSalesRow = `Total,${totalSalesAmount.toFixed(2)}`;



            // Generate CSV content for Carrier
            const headerCustomer = CUSTOMER_TABLE_CELLS.map(field => field.label).join(',');
            const rowsCustomer = customerSummary
              .filter(row => row.name !== "Total")
              .map(row =>
                CUSTOMER_TABLE_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                    return value;
                }).join(',')
              );

            // Calculate total for Carrier
            const totalCustomerAmount = rowsCustomer.reduce((acc, row) => {
                const [name, totalBalance] = row.split(',');
                return acc + parseFloat(totalBalance || 0);
            }, 0);
            const totalCustomerRow = `Total,${totalCustomerAmount.toFixed(2)}`;


            // Generate CSV content for Other
            const headerOther = LEDGER_PAYABLE_ENTRIES_CELLS.map(field => field.label).join(',');
            const rowsOther = templates
              .filter(row => row.description !== "Sales")
              .map(row =>
                LEDGER_PAYABLE_ENTRIES_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                    return value;
                }).join(',')
              );

            // Calculate total for Supplier
            const totalOtherAmount = rowsOther.reduce((acc, row) => {
                const [description, credit] = row.split(',');
                return acc + parseFloat(credit || 0);
            }, 0);
            const totalOtherRow = `Total,${totalOtherAmount.toFixed(2)}`;


            const total = totalSalesAmount + totalCustomerAmount + totalOtherAmount;
            const salesTotal = `Sales Total,${total.toFixed(2)}`;

            // Combine headers, rows, and totals, ensuring "Total" is last
            csvContent = [
                headerSales,
                ...mappedMarketplaces,
                totalSalesRow,
                '', // Empty line between tables
                headerCustomer,
                ...rowsCustomer,
                totalCustomerRow,
                '', // Empty line between tables
                headerOther,
                ...rowsOther,
                totalOtherRow,
                '', // Empty line between tables
                salesTotal
            ].join('\n');
        }
        else if (this.props.ledger.name === "Accounts Receivables"){
            const { marketplaceSummary, customerSummary, templates } = this.state;

            // Generate CSV content for Carrier
            const headerMarketplace = MARKETPLACE_TABLE_CELLS.map(field => field.label).join(',');
            const rowsMarketplace = marketplaceSummary
              .filter(row => row.name !== "Total")
              .map(row =>
                MARKETPLACE_TABLE_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                    return value;
                }).join(',')
              );

            const mappedMarketplaces = rowsMarketplace.map(row => {
                const [key, amount] = row.split(',');
                return `${MARKETPLACE_MAPPING[key] || key},${parseFloat(amount).toFixed(2)}`;
            });


            // Calculate total for Carrier
            const totalMarketplaceAmount = mappedMarketplaces.reduce((acc, row) => {
                const [name, totalBalance] = row.split(',');
                return acc + parseFloat(totalBalance || 0);
            }, 0);
            const totalMarketplaceRow = `Total,${totalMarketplaceAmount.toFixed(2)}`;



            // Generate CSV content for Carrier
            const headerCustomer = CUSTOMER_TABLE_CELLS.map(field => field.label).join(',');
            const rowsCustomer = customerSummary
              .filter(row => row.name !== "Total")
              .map(row =>
                CUSTOMER_TABLE_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                    return value;
                }).join(',')
              );

            // Calculate total for Carrier
            const totalCustomerAmount = rowsCustomer.reduce((acc, row) => {
                const [name, totalBalance] = row.split(',');
                return acc + parseFloat(totalBalance || 0);
            }, 0);
            const totalCustomerRow = `Total,${totalCustomerAmount.toFixed(2)}`;

            // Generate CSV content for Other
            const headerOther = LEDGER_PAYABLE_ENTRIES_CELLS.map(field => field.label).join(',');
            const rowsOther = templates
              .filter(row => row.description !== "Accounts Receivables")
              .map(row =>
                LEDGER_PAYABLE_ENTRIES_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                    return value;
                }).join(',')
              );

            // Calculate total for Supplier
            const totalOtherAmount = rowsOther.reduce((acc, row) => {
                const [description, credit] = row.split(',');
                return acc + parseFloat(credit || 0);
            }, 0);
            const totalOtherRow = `Total,${totalOtherAmount.toFixed(2)}`;


            const total = totalMarketplaceAmount + totalCustomerAmount + totalOtherAmount;
            const accountsReceivablesTotal = `Accounts Receivables Total,${total.toFixed(2)}`;

            // Combine headers, rows, and totals, ensuring "Total" is last
            csvContent = [
                headerMarketplace,
                ...mappedMarketplaces,
                totalMarketplaceRow,
                '', // Empty line between tables
                headerCustomer,
                ...rowsCustomer,
                totalCustomerRow,
                '', // Empty line between tables
                headerOther,
                ...rowsOther,
                totalOtherRow,
                '', // Empty line between tables
                accountsReceivablesTotal
            ].join('\n');
        }
        else if (this.props.ledger.name === "Cash"){
            const { templates, bankAccountSummary, outstandingChequesSummary } = this.state;


            // Generate CSV content for bank accounts Summary
            const headerBankSummary = BANK_ACCOUNT_SUMMARY_TABLE_CELLS.map(field => field.label).join(',');
            const rowBanks = bankAccountSummary
              .filter(row => row.name !== "Total")
              .map(row =>
                BANK_ACCOUNT_SUMMARY_TABLE_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value;
                    return value;
                }).join(',')
              );

            // Calculate total for Carrier
            const totalBankAccountAmount = rowBanks.reduce((acc, row) => {
                const [name, totalBalance] = row.split(',');
                return acc + parseFloat(totalBalance || 0);
            }, 0);
            const totalBankRow = `Total,${totalBankAccountAmount.toFixed(2)}`;


            // Generate CSV content for outstanding cheques summary
            const headerOutstandingChequesSummary = OUTSTANDING_CHEQUES_SUMMARY_TABLE_CELLS.map(field => field.label).join(',');
            const rowOutstandingCheques = outstandingChequesSummary
              .filter(row => row.name !== "Total")
              .map(row =>
                OUTSTANDING_CHEQUES_SUMMARY_TABLE_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value;
                    return value;
                }).join(',')
              );

            // Calculate total for Carrier
            const totalOutstandingChequesAmount = rowOutstandingCheques.reduce((acc, row) => {
                const [name, totalBalance] = row.split(',');
                return acc + parseFloat(totalBalance || 0);
            }, 0);
            const totalOutstandingChequesRow = `Total,${totalOutstandingChequesAmount.toFixed(2)}`;


            // Generate CSV content for Other
            const headerOther = LEDGER_PAYABLE_ENTRIES_CELLS.map(field => field.label).join(',');
            const rowsOther = templates
              .filter(row => row.description !== "Cash")
              .map(row =>
                LEDGER_PAYABLE_ENTRIES_CELLS.map(field => {
                    let value = row[field.id] ?? '';
                    value = value.toString().includes(',') ? `"${value}"` : value; // Wrap values with commas in quotes
                    return value;
                }).join(',')
              );

            // Calculate total for Supplier
            const totalOtherAmount = rowsOther.reduce((acc, row) => {
                const [description, credit] = row.split(',');
                return acc + parseFloat(credit || 0);
            }, 0);
            const totalOtherRow = `Total,${totalOtherAmount.toFixed(2)}`;

            const total = totalBankAccountAmount +  totalOutstandingChequesAmount + totalOtherAmount;
            const cashTotal = `Cash Total,${total.toFixed(2)}`;

            // Combine headers, rows, and totals, ensuring "Total" is last
            csvContent = [
                headerBankSummary,
                ...rowBanks,
                totalBankRow,
                '', // Empty line between tables
                 headerOutstandingChequesSummary,
                ...rowOutstandingCheques,
                totalOutstandingChequesRow,
                '', // Empty line between tables
                headerOther,
                ...rowsOther,
                totalOtherRow,
                '', // Empty line between tables
                cashTotal
            ].join('\n');
        }

        // Create a Blob from the CSV content
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        // Create and trigger the download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${ledgerName}_${this.props.selectedYear}_${this.props.selectedCurrency}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    handleExport = () => {

        const ledgerName = this.state.isShowMarketplaceDetails
          ? `Ledger - ${this.props.ledger.name} (${MARKETPLACE_MAPPING[this.state.selectedMarketplace.name] ?? this.state.selectedMarketplace.name})`
          : `Ledger - ${this.props.ledger.name}`;

        const { templates } = this.state;
        if (!templates || templates.length === 0) {
            return;
        }

        // Generate CSV content
        const headers = LEDGER_ENTRIES_CELLS.map(field => field.label).join(',');
        const rows = templates.map(row =>
          LEDGER_ENTRIES_CELLS.map(field => {
              let value = row[field.id] ?? '';
              value = value.toString().includes(',') ? `"${value}"` : value;
              return value;
          }).join(',')
        );

        const cleanRows = rows.map(row =>
          row.split(',').map(value => value.trim() === "0.00" ? '' : value).join(',')
        );

        const csvContent = [headers, ...cleanRows].join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        //Create and trigger download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${ledgerName}_${this.props.selectedYear}_${this.props.selectedCurrency}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    updateMarketplace = () => {
        // Clear current entries
        const updatedMarketplace = { ...this.state.selectedMarketplace, entries: [] };

        // Copy entries from marketplaceEntries
        this.state.marketplaceEntries.forEach(entry => {
            updatedMarketplace.entries.push({ ...entry });
        });

        // Calculate the total balance from the last entry
        const lastEntry = this.state.marketplaceEntries[this.state.marketplaceEntries.length - 1];
        updatedMarketplace.totalBalance = lastEntry ? parseFloat(lastEntry.balance) : 0.00;

        return updatedMarketplace
    };


    handleMarketplaceEntriesSave = () => {
        const updatedMarketplace = this.updateMarketplace()
        this.props.saveMarketplaceLedger({marketplace: updatedMarketplace,
            ledgerId: this.props.ledger.ledgerId,
            year: this.props.selectedYear, currency: this.props.selectedCurrency});
        this.setState({isEditMarketplace: false});
    }

    handleSave = () => {
        this.props.handleSave(this.state.templates, this.props.ledger.ledgerId);
        this.setState({isEditEntries: false});
    }

    isSaveDisabled = () => {
        return this.state.templates.some((template, index) => {
            // Your existing "isReservedError" logic extracted for reuse
            const isReservedError = !template.transactionId &&
                                    !template.journalEntryId &&
                                    template.description?.trim().toLowerCase() === 'opening balance';

            return (
                !template.description ||
                !template.debit ||
                !template.credit ||
                !template.balance ||
                isReservedError // This prevents saving if the error is present
            );
        });
    };

    formatDollar = (amount, forceTwoDecimals) => {

        if (amount === null || amount === undefined || amount === 0) {
            return "0.00";
        }

        let value;
        const amountStr = amount.toString(); // Convert to string to safely use match and replaceAll

        if (forceTwoDecimals) {
            value = this.parseNumber(amount).toFixed(2);
        } else {
            // If the amount has more than two decimal places, limit it to two
            if (amountStr.match(/.*\.\d{2}.*/)) {
                try {
                    value = this.parseNumber(amount).toFixed(2);
                } catch {
                    value = amountStr.replaceAll(',', '');
                }
            } else {
                value = amountStr.replaceAll(',', '');

            }
        }
        return value
    }

    formatAmount = (amount) => {

        if (amount === null || amount === undefined || amount === 0) {
            return "0.00";
        }

        let value;
        const amountStr = amount.toString(); // Convert to string to safely use match and replaceAll


        // If the amount has more than two decimal places, limit it to two
        if (amountStr.match(/.*\.\d{2}.*/)) {
            try {
                value = this.parseNumber(amount).toFixed(2);
            } catch {
                value = amountStr.replaceAll(',', '');
            }
        } else {
            value = amountStr.replaceAll(',', '');

        }

        return value.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }


    parseNumber = (value) => {
        if (typeof value === 'number') {
            return value;
        }
        if (typeof value === 'string') {
            return parseFloat(value.replace(/,/g, ''))
        }
        return NaN;
    }

    handleTemplateDateChange = (date, index, entry = null) => {

        this.setState(prevState => {
            const updatedTemplates = [...prevState.templates];
            updatedTemplates[index] = {
                ...updatedTemplates[index],
                "date": date,

            };

            return {templates: updatedTemplates};
        });
    };


    handleTemplateChange = (e, index, entry = null) => {
        let {name, value} = e.target;

        // Disable changes for debit and credit at index 0
        if (index === 0 && entry.description === 'Opening Balance' && (name === 'debit' || name === 'credit')) {
            return; // Prevent changes to debit or credit at index 0
        }
        this.setState(prevState => {
            const updatedTemplates = [...prevState.templates];
            updatedTemplates[index] = {
                ...updatedTemplates[index],
                [name]: value,

            };

            return {templates: updatedTemplates};
        });
    };


    removeTemplateRow = (index) => {
        this.setState(prevState => {
            const updatedTemplates = prevState.templates.filter((_, curIndex) => curIndex !== index);
            return {templates: updatedTemplates};
        }, this.updateBalances);
    };

    addTemplateRow = () => {
        const {selectedYear} = this.props;
        const date = selectedYear === new Date().getFullYear().toString()
            ? new Date(Date.now()) // Use current date for the current year
            : new Date(`${selectedYear}-01-02`); // Use January 1st of the selected year

        this.setState(prevState => {
            const updatedTemplates = [...prevState.templates, {
                date: date, // Use the calculated date
                description: "",
                debit: "0.00",
                credit: "0.00",
                balance: "0.00",
                currency: this.props.selectedCurrency,
                transactionId: null,
                notes : ''
            }];
            return {templates: updatedTemplates};
        }, this.updateBalances);
    };

    updateBalances = () => {
        this.setState(prevState => {
            const updatedTemplates = prevState.templates.map((template, index) => {
                let previousBalance;

                if (index === 0) {
                    // Set the opening balance for the first entry
                    previousBalance = this.parseNumber(template.balance);
                } else {
                    previousBalance = this.parseNumber(prevState.templates[index - 1].balance);
                }

                let debit = template.debit ? this.parseNumber(template.debit) : 0;
                let credit = template.credit ? this.parseNumber(template.credit) : 0;


                let newBalance = previousBalance;


                if (index !== 0) { // Skip balance calculation for the opening balance
                    switch (this.props.ledger.type) {
                        case 'Assets':
                        case 'Expenses':
                            newBalance += (debit - credit);
                            break;
                        case 'Income':
                        case 'Equity':
                        case 'Liabilities':
                            newBalance += (credit - debit);
                            break;
                        default:
                            console.warn(`Unknown ledger type: ${template.type}`);
                    }
                } else if (index === 0 && template.description !== 'Opening Balance') {
                    switch (this.props.ledger.type) {
                        case 'Assets':
                        case 'Expenses':
                            newBalance = (debit - credit);
                            break;
                        case 'Income':
                        case 'Equity':
                        case 'Liabilities':
                            newBalance = (credit - debit);
                            break;
                        default:
                            console.warn(`Unknown ledger type: ${template.type}`);
                    }
                }

                template.balance = this.formatDollar(newBalance.toFixed(2));
                return template;
            });

            return {templates: updatedTemplates};
        });
    }

    removeMarketplaceRow = (index) => {
        this.setState(prevState => {
            const updatedTemplates = prevState.marketplaceEntries.filter((_, curIndex) => curIndex !== index);
            return {marketplaceEntries: updatedTemplates};
        }, this.updateMarketplaceBalances);
    };

    addMarketplaceRow = () => {
        this.setState(prevState => {
            const updatedTemplates = [...prevState.marketplaceEntries, {
                description: "",
                debit: "0.00",
                credit: "0.00",
                balance: "0.00",
                currency: this.props.selectedCurrency,
                transactionId: null,
            }];
            return {marketplaceEntries: updatedTemplates};
        }, this.updateMarketplaceBalances);
    };


    handleMarketplaceChange = (e, index, entry = null) => {
        let {name, value} = e.target;

        // Disable changes for debit and credit at index 0
        if (index === 0 && entry.description === 'Opening Balance' && (name === 'debit' || name === 'credit')) {
            return; // Prevent changes to debit or credit at index 0
        }

        this.setState(prevState => {
            const updatedTemplates = [...prevState.marketplaceEntries];
            updatedTemplates[index] = {
                ...updatedTemplates[index],
                [name]: value,

            };

            return {marketplaceEntries: updatedTemplates};
        });
    };

    updateMarketplaceBalances = () => {
        this.setState(prevState => {
            const updatedTemplates = prevState.marketplaceEntries.map((template, index) => {
                let previousBalance;

                if (index === 0) {
                    // Set the opening balance for the first entry
                    previousBalance = this.parseNumber(template.balance);
                } else {
                    previousBalance = this.parseNumber(prevState.marketplaceEntries[index - 1].balance);
                }

                let debit = template.debit ? this.parseNumber(template.debit) : 0;
                let credit = template.credit ? this.parseNumber(template.credit) : 0;


                let newBalance = previousBalance;


                if (index !== 0) { // Skip balance calculation for the opening balance
                    switch (this.props.ledger.type) {
                        case 'Assets':
                        case 'Expenses':
                            newBalance += (debit - credit);
                            break;
                        case 'Income':
                        case 'Equity':
                        case 'Liabilities':
                            newBalance += (credit - debit);
                            break;
                        default:
                            console.warn(`Unknown ledger type: ${template.type}`);
                    }
                } else if (index === 0 && template.description !== 'Opening Balance') {
                    switch (this.props.ledger.type) {
                        case 'Assets':
                        case 'Expenses':
                            newBalance = (debit - credit);
                            break;
                        case 'Income':
                        case 'Equity':
                        case 'Liabilities':
                            newBalance = (credit - debit);
                            break;
                        default:
                            console.warn(`Unknown ledger type: ${template.type}`);
                    }
                }

                template.balance = this.formatDollar(newBalance.toFixed(2));
                return template;
            });

            return {marketplaceEntries: updatedTemplates};
        });
    }

    handleMarketplaceBlur = (e, index) => {
        let {name, value} = e.target;
        if (name === 'debit' || name === 'credit' || name === 'balance') {
            value = this.formatDollar(value);
        }
        this.setState(prevState => {
            const updatedTemplates = [...prevState.marketplaceEntries];
            updatedTemplates[index] = {
                ...updatedTemplates[index],
                [name]: isNaN(parseFloat(value)) ? "0.00" : this.formatDollar(value, true),
            };
            return {marketplaceEntries: updatedTemplates};
        }, this.updateMarketplaceBalances);
    };

    handleBlur = (e, index) => {
        let {name, value} = e.target;
        if (name === 'debit' || name === 'credit' || name === 'balance') {
            value = this.formatDollar(value);
        }
        this.setState(prevState => {
            const updatedTemplates = [...prevState.templates];
            updatedTemplates[index] = {
                ...updatedTemplates[index],
                [name]: isNaN(parseFloat(value)) ? "0.00" : this.formatDollar(value, true),
            };
            return {templates: updatedTemplates};
        }, this.updateBalances);
    };

    // Whether a section belongs to the currently open predefined ledger — drives which sub-tables
    // render, using the same LEDGER_SECTIONS source of truth as the audit preview.
    sectionAllowed = (key) => (LEDGER_SECTIONS[this.props.ledger.name] || []).includes(key)

    // Shared header for every predefined sub-table. Predefined sections can render with no rows (a
    // section that belongs to the ledger but has no data), so — together with table-layout:fixed via
    // the ledger-fixed-table wrapper — these explicit widths make the columns come from the header
    // alone, keeping empty and populated tables aligned. Widths mirror the populated rows: a ~76px
    // hidden icon cell each side, a 100% label cell, a 199px amount cell.
    getSummaryTableHeaders = (cells) => {
        let headers = []
        headers.push(Layout.columnHead(" ", "spacerLeft", "left", "76px"))
        cells.forEach((headCell, index) => {
            headers.push(Layout.columnHead(headCell.label, headCell.id, headCell.align, index === 0 ? "100%" : "199px"))
        })
        headers.push(Layout.columnHead(" ", "spacerRight", "left", "76px"))
        return headers
    }

    getPayableTableHeaders = () => this.getSummaryTableHeaders(LEDGER_PAYABLE_ENTRIES_CELLS)

    getTableHeaders = () => {
        let headers = []
        headers.push(Layout.columnHead(null, null,null))
        LEDGER_ENTRIES_CELLS.forEach((headCell, index) => {
            headers.push(Layout.columnHead(headCell.label, headCell.id, headCell.align))
        })
        headers.push(Layout.columnHead(null, null,null))
        return headers
    }

    getMarketplaceEntriesTableHeaders = () => {
        let headers = []
        headers.push(Layout.columnHead(null, null,null))
        MARKETPLACE_ENTRIES_CELLS.forEach((headCell, index) => {
            headers.push(Layout.columnHead(headCell.label, null, headCell.align))
        })
        headers.push(Layout.columnHead(null, null,null))
        return headers
    }

    getStockTableHeaders = () => this.getSummaryTableHeaders(STOCK_IN_HAND_TABLE_CELLS)

    getCarrierTableHeaders = () => this.getSummaryTableHeaders(CARRIER_TABLE_CELLS)

    getMarketplaceTableHeaders = () => this.getSummaryTableHeaders(MARKETPLACE_TABLE_CELLS)

    getFTLTableHeaders = () => this.getSummaryTableHeaders(FTL_CARRIER_TABLE_CELLS)

    getSupplierTableHeaders = () => this.getSummaryTableHeaders(SUPPLIER_TABLE_CELLS)

    getOutstandingChequesTableHeaders = () => this.getSummaryTableHeaders(OUTSTANDING_CHEQUES_SUMMARY_TABLE_CELLS)

    getCreditCardBalancesTableHeaders = () => this.getSummaryTableHeaders(CREDIT_CARD_BALANCES_SUMMARY_TABLE_CELLS)

    getBankAccountsTableHeaders = () => this.getSummaryTableHeaders(BANK_ACCOUNT_SUMMARY_TABLE_CELLS)

    getCustomerTableHeaders = () => this.getSummaryTableHeaders(CUSTOMER_TABLE_CELLS)

    getSalesTableHeaders = () => this.getSummaryTableHeaders(SALES_TABLE_CELLS)

    formatDate = (date) => {
        try {
            const parsedDate = new Date(date);
            if (isNaN(parsedDate)) {
                throw new Error('Invalid Date');
            }
            return format(parsedDate, 'yyyy-MM-dd');
        } catch (e) {
            return date;
        }
    };

    formatBalance = (balance) => {
        return parseFloat(balance)
            .toFixed(2)
            .toString()
            .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    }

    setLedgerEntries = (ledgerEntries) => {
        this.setState({templates: ledgerEntries})
    }

    setStockEntries = (summary) => {
        this.setState({stockSummary: summary})
    }

    getStockTableRow = (row, getRowState, setRowState) => {
        return<StockEntryTableRow
          row={row}
          isEditPayable={this.state.isEditPayable}
          stockSummary={this.state.stockSummary}
          setStockEntries={this.setStockEntries}
          getRowState={getRowState}
          setRowState={setRowState}
          setCurrentPage={this.props.setCurrentPage}
          listingIdBeingEdited={this.state.listingIdBeingEdited}
          setListingIdBeingEdited={(newId) => this.setState({listingIdBeingEdited: newId})}
          year={this.props.selectedYear}
          currency={this.props.selectedCurrency}
          updateEntry={this.props.updateEntry}
          deleteEntry={this.props.deleteEntry}
          ledgerId={this.props.ledger.ledgerId}
          setHideFilterBox={this.setHideFilterBox}
          categories={this.props.categories}
          ledgerType={this.props.ledger.type}

        />
    }

    setCarrierEntries = (summary) => {
        this.setState({carrierSummary: summary})
    }

    getCarrierTableRow = (row, getRowState, setRowState) => {
        return<CarrierEntryTableRow
          row={row}
          isEditPayable={this.state.isEditPayable}
          carrierSummary={this.state.carrierSummary}
          setCarrierEntries={this.setCarrierEntries}
          getRowState={getRowState}
          setRowState={setRowState}
          setCurrentPage={this.props.setCurrentPage}
          listingIdBeingEdited={this.state.listingIdBeingEdited}
          setListingIdBeingEdited={(newId) => this.setState({listingIdBeingEdited: newId})}
          year={this.props.selectedYear}
          currency={this.props.selectedCurrency}
          updateEntry={this.props.updateEntry}
          deleteEntry={this.props.deleteEntry}
          ledgerId={this.props.ledger.ledgerId}
          setHideFilterBox={this.setHideFilterBox}
          categories={this.props.categories}
          ledgerType={this.props.ledger.type}
          onOpenNotesDialog={this.handleOpenSummaryNotesDialog}
        />
    }

    setCustomerEntries = (summary) => {
        this.setState({customerSummary: summary})
    }

    setCreditCardBalancesEntries = (summary) => {
        this.setState({creditCardBalancesSummary: summary})
    }

    setBankAccountEntries = (summary) => {
        this.setState({bankAccountSummary: summary})
    }

    setOutstandingChequesEntries = (summary) => {
        this.setState({outstandingChequesSummary: summary})
    }

    getOutstandingChequesTableRow = (row, getRowState, setRowState) => {
        return<OutstandingChequesEntryTableRow
          row={row}
          isEditPayable={this.state.isEditPayable}
          outstandingChequesSummary={this.state.outstandingChequesSummary}
          setOutstandingChequesEntries={this.setOutstandingChequesEntries}
          getRowState={getRowState}
          setRowState={setRowState}
          setCurrentPage={this.props.setCurrentPage}
          listingIdBeingEdited={this.state.listingIdBeingEdited}
          setListingIdBeingEdited={(newId) => this.setState({listingIdBeingEdited: newId})}
          year={this.props.selectedYear}
          currency={this.props.selectedCurrency}
          updateEntry={this.props.updateEntry}
          deleteEntry={this.props.deleteEntry}
          ledgerId={this.props.ledger.ledgerId}
          setHideFilterBox={this.setHideFilterBox}
          categories={this.props.categories}
          ledgerType={this.props.ledger.type}
          onOpenNotesDialog={this.handleOpenSummaryNotesDialog}
        />
    }

     getCreditCardBalancesTableRow = (row, getRowState, setRowState) => {
        return<CreditCardBalancesEntryTableRow
          row={row}
          isEditPayable={this.state.isEditPayable}
          creditCardBalancesSummary={this.state.creditCardBalancesSummary}
          setCreditCardBalancesEntries={this.setCreditCardBalancesEntries}
          getRowState={getRowState}
          setRowState={setRowState}
          setCurrentPage={this.props.setCurrentPage}
          listingIdBeingEdited={this.state.listingIdBeingEdited}
          setListingIdBeingEdited={(newId) => this.setState({listingIdBeingEdited: newId})}
          year={this.props.selectedYear}
          currency={this.props.selectedCurrency}
          updateEntry={this.props.updateEntry}
          deleteEntry={this.props.deleteEntry}
          ledgerId={this.props.ledger.ledgerId}
          setHideFilterBox={this.setHideFilterBox}
          categories={this.props.categories}
          ledgerType={this.props.ledger.type}
          onOpenNotesDialog={this.handleOpenSummaryNotesDialog}
        />
    }

    getBankAccountTableRow = (row, getRowState, setRowState) => {
        return<BankAccountEntryTableRow
          row={row}
          isEditPayable={this.state.isEditPayable}
          bankAccountSummary={this.state.bankAccountSummary}
          setBankAccountEntries={this.setBankAccountEntries}
          getRowState={getRowState}
          setRowState={setRowState}
          setCurrentPage={this.props.setCurrentPage}
          listingIdBeingEdited={this.state.listingIdBeingEdited}
          setListingIdBeingEdited={(newId) => this.setState({listingIdBeingEdited: newId})}
          year={this.props.selectedYear}
          currency={this.props.selectedCurrency}
          updateEntry={this.props.updateEntry}
          deleteEntry={this.props.deleteEntry}
          ledgerId={this.props.ledger.ledgerId}
          setHideFilterBox={this.setHideFilterBox}
          categories={this.props.categories}
          ledgerType={this.props.ledger.type}
          onOpenNotesDialog={this.handleOpenSummaryNotesDialog}
        />
    }

    getCustomerTableRow = (row, getRowState, setRowState) => {
        return<CustomerEntryTableRow
          row={row}
          isEditPayable={this.state.isEditPayable}
          customerSummary={this.state.customerSummary}
          setCustomerEntries={this.setCustomerEntries}
          getRowState={getRowState}
          setRowState={setRowState}
          setCurrentPage={this.props.setCurrentPage}
          listingIdBeingEdited={this.state.listingIdBeingEdited}
          setListingIdBeingEdited={(newId) => this.setState({listingIdBeingEdited: newId})}
          year={this.props.selectedYear}
          currency={this.props.selectedCurrency}
          updateEntry={this.props.updateEntry}
          deleteEntry={this.props.deleteEntry}
          ledgerId={this.props.ledger.ledgerId}
          setHideFilterBox={this.setHideFilterBox}
          categories={this.props.categories}
          ledgerType={this.props.ledger.type}
          onOpenNotesDialog={this.handleOpenSummaryNotesDialog}
        />
    }

    setSalesEntries = (summary) => {
        this.setState({salesSummary: summary})
    }

    getSalesTableRow = (row, getRowState, setRowState) => {
        return<SalesEntryTableRow
          row={row}
          isEditPayable={this.state.isEditPayable}
          salesSummary={this.state.salesSummary}
          setSalesEntries={this.setSalesEntries}
          getRowState={getRowState}
          setRowState={setRowState}
          setCurrentPage={this.props.setCurrentPage}
          listingIdBeingEdited={this.state.listingIdBeingEdited}
          setListingIdBeingEdited={(newId) => this.setState({listingIdBeingEdited: newId})}
          year={this.props.selectedYear}
          currency={this.props.selectedCurrency}
          updateEntry={this.props.updateEntry}
          deleteEntry={this.props.deleteEntry}
          ledgerId={this.props.ledger.ledgerId}
          setHideFilterBox={this.setHideFilterBox}
          categories={this.props.categories}
          ledgerType={this.props.ledger.type}
          onOpenNotesDialog={this.handleOpenSummaryNotesDialog}
        />
    }


    setSupplierEntries = (summary) => {
        this.setState({supplierSummary: summary})
    }

    getSupplierTableRow = (row, getRowState, setRowState) => {
        return<SupplierEntryTableRow
          row={row}
          isEditPayable={this.state.isEditPayable}
          supplierSummary={this.state.supplierSummary}
          setSupplierEntries={this.setSupplierEntries}
          getRowState={getRowState}
          setRowState={setRowState}
          setCurrentPage={this.props.setCurrentPage}
          listingIdBeingEdited={this.state.listingIdBeingEdited}
          setListingIdBeingEdited={(newId) => this.setState({listingIdBeingEdited: newId})}
          year={this.props.selectedYear}
          currency={this.props.selectedCurrency}
          updateEntry={this.props.updateEntry}
          deleteEntry={this.props.deleteEntry}
          ledgerId={this.props.ledger.ledgerId}
          setHideFilterBox={this.setHideFilterBox}
          categories={this.props.categories}
          ledgerType={this.props.ledger.type}
          onOpenNotesDialog={this.handleOpenSummaryNotesDialog}
        />
    }


    setFTLEntries = (summary) => {
        this.setState({ftlSummary: summary})
    }

    getFTLTableRow = (row, getRowState, setRowState) => {
        return<FTLEntryTableRow
          row={row}
          isEditPayable={this.state.isEditPayable}
          ftlSummary={this.state.ftlSummary}
          setFTLEntries={this.setFTLEntries}
          getRowState={getRowState}
          setRowState={setRowState}
          setCurrentPage={this.props.setCurrentPage}
          listingIdBeingEdited={this.state.listingIdBeingEdited}
          setListingIdBeingEdited={(newId) => this.setState({listingIdBeingEdited: newId})}
          year={this.props.selectedYear}
          currency={this.props.selectedCurrency}
          updateEntry={this.props.updateEntry}
          deleteEntry={this.props.deleteEntry}
          ledgerId={this.props.ledger.ledgerId}
          setHideFilterBox={this.setHideFilterBox}
          categories={this.props.categories}
          ledgerType={this.props.ledger.type}
          onOpenNotesDialog={this.handleOpenSummaryNotesDialog}
        />
    }


    setShowMarketplaceDetails = (bool,row) =>{
        this.setState({isShowMarketplaceDetails: bool,selectedMarketplace: row, marketplaceEntries: [...row.entries]},()=>{
            this.updateMarketplaceBalances()
        })
    }

    setMarketplaceEntries = (summary) => {
        this.setState({marketplaceSummary: summary})
    }

    getMarketplaceTableRow = (row, getRowState, setRowState) => {
        return<MarketplaceEntryTableRow
          row={row}
          isEditPayable={this.state.isEditPayable}
          marketplaceSummary={this.state.marketplaceSummary}
          setMarketplaceEntries={this.setMarketplaceEntries}
          getRowState={getRowState}
          setRowState={setRowState}
          setCurrentPage={this.props.setCurrentPage}
          listingIdBeingEdited={this.state.listingIdBeingEdited}
          setListingIdBeingEdited={(newId) => this.setState({listingIdBeingEdited: newId})}
          year={this.props.selectedYear}
          currency={this.props.selectedCurrency}
          updateEntry={this.props.updateEntry}
          deleteEntry={this.props.deleteEntry}
          ledgerId={this.props.ledger.ledgerId}
          setHideFilterBox={this.setHideFilterBox}
          categories={this.props.categories}
          ledgerType={this.props.ledger.type}
          setShowMarketplaceDetails={this.setShowMarketplaceDetails}
          onOpenNotesDialog={this.handleOpenSummaryNotesDialog}
        />
    }

    getPayableTableRow = (row, getRowState, setRowState,ledgerType) => {
        return<LedgerEntryTableRow
            row={row}
            isEditPayable={this.state.isEditPayable}
            allLedgers={this.state.templates}
            setLedgerEntries={this.setLedgerEntries}
            getRowState={getRowState}
            setRowState={setRowState}
            setCurrentPage={this.props.setCurrentPage}
            listingIdBeingEdited={this.state.listingIdBeingEdited}
            setListingIdBeingEdited={(newId) => this.setState({listingIdBeingEdited: newId})}
            year={this.props.selectedYear}
            currency={this.props.selectedCurrency}
            ledgerType={ledgerType}
            updateEntry={this.props.updateEntry}
            deleteEntry={this.props.deleteEntry}
            ledgerId={this.props.ledger.ledgerId}
            setHideFilterBox={this.setHideFilterBox}
            categories={this.props.categories}
            ledgerCategories={this.props.allLedgers}
            onOpenNotesDialog={this.handleOpenSummaryNotesDialog}
        />
    }

    getMarketplaceDetailsTableRow = (row) => {
      return (
        <React.Fragment>
          <TableCell
            style={{
              width: '120px',
              height: '90px',
              padding: '0',
              margin: '0',
            }}
          >
            {row.note ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Tooltip title={row.note}>
                  <IconButton
                    onClick={() => this.handleOpenViewMarketplaceNoteDialog(row.note)}
                  >
                    <TextSnippetIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </div>
            ) : null}
          </TableCell>

          <TableCell
            style={{
              textAlign: 'right',
              padding: '5px',
              paddingRight: '50px',
              width: 'auto',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              {row.description}
            </div>
          </TableCell>

          <TableCell
            style={{
              textAlign: 'right',
              padding: '5px',
              paddingRight: '50px',
              width: 'auto',
            }}
          >
            {this.formatBalance(row.debit) !== '0.00' && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                <span style={{ flexShrink: 0 }}>$</span>
                <span
                  style={{
                    marginLeft: '55px',
                    minWidth: '80px',
                    textAlign: 'right',
                  }}
                >
                  {this.formatBalance(row.debit)}
                </span>
              </div>
            )}
          </TableCell>

          <TableCell
            style={{
              textAlign: 'right',
              padding: '5px',
              paddingRight: '50px',
              width: 'auto',
            }}
          >
            {this.formatBalance(row.credit) !== '0.00' && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                <span style={{ flexShrink: 0 }}>$</span>
                <span
                  style={{
                    marginLeft: '55px',
                    minWidth: '80px',
                    textAlign: 'right',
                  }}
                >
                  {this.formatBalance(row.credit)}
                </span>
              </div>
            )}
          </TableCell>

          <TableCell
            style={{
              textAlign: 'right',
              padding: '5px',
              paddingRight: '50px',
              width: 'auto',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'left',
              }}
            >
              <span style={{ flexShrink: 0 }}>$</span>
              <span
                style={{
                  marginLeft: '55px',
                  minWidth: '80px',
                  textAlign: 'right',
                }}
              >
                {this.formatBalance(row.balance)}
              </span>
            </div>
          </TableCell>
        </React.Fragment>
      );
    };

    // A computed sub-ledger entry carries the referenced sub-ledger's ledgerId as its
    // own transactionId (regular entries have a null transactionId). That is the most
    // reliable signal. We also handle the explicit `category` reference and an entry
    // whose name matches a hidden sub-ledger -- without depending on `source`, which
    // can come back null for computed sub-ledger rows.
    getLinkedLedger = (row) => {
        if (!row || row.journalEntryId) {
            return null;
        }
        const allLedgers = this.props.allLedgers || [];
        const currentLedgerId = this.props.ledger?.ledgerId;

        // Primary: transactionId matches another ledger's ledgerId.
        if (row.transactionId) {
            const byId = allLedgers.find(
              (l) => l.ledgerId === row.transactionId && l.ledgerId !== currentLedgerId
            );
            if (byId) {
                return byId;
            }
        }

        // The category array is the explicit reference -- match it against any ledger.
        let categoryNames = [];
        if (Array.isArray(row.category)) {
            categoryNames = row.category;
        } else if (typeof row.category === 'string' && row.category) {
            categoryNames = [row.category];
        }
        for (let i = 0; i < categoryNames.length; i++) {
            const match = allLedgers.find(
              (l) => l.name === categoryNames[i] && l.ledgerId !== currentLedgerId
            );
            if (match) {
                return match;
            }
        }

        // Fall back to the entry's own name matching a hidden sub-ledger.
        if (row.description) {
            const byDesc = allLedgers.find(
              (l) =>
                l.name === row.description &&
                l.isShowTrialBalance === false &&
                l.ledgerId !== currentLedgerId
            );
            if (byDesc) {
                return byDesc;
            }
        }

        return null;
    };

    // Style an entry's description as a link when it references a sub-ledger.
    // The whole row is clickable (see getTableRow), so this only adds the visual cue.
    renderEntryDescription = (row) => {
        const linkedLedger = this.getLinkedLedger(row);
        if (linkedLedger) {
            return (
              <span style={{ color: '#005E73', fontWeight: 500 }}>
                  {row.description}
              </span>
            );
        }
        return row.description;
    };

    getTableRow = (row, getRowState, setRowState) => {
      const linkedLedger = this.getLinkedLedger(row);
      const navigateToLinked = linkedLedger
        ? () => this.props.navigateToSubLedger(linkedLedger)
        : undefined;
      const cursor = linkedLedger ? 'pointer' : undefined;
      const linkStyle = linkedLedger ? { color: '#005E73', fontWeight: 500 } : {};
      return (
        <React.Fragment>


          <TableCell
            onClick={navigateToLinked}
            style={{
              width: '120px',
              height: '90px',
              padding: '0',
              margin: '0',
              cursor,
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center',marginLeft:'24px' }}>
              {/* // new update: Only show icon if row.note exists */}
              {row.note && (
                <Tooltip title={row.note} arrow>
                  <IconButton
                    size="small"
                    style={{ marginRight: '4px' }}
                    // // new update: Added click handler to trigger the same dialog logic as the form view
                    onClick={(e) => {
                      e.stopPropagation();
                      this.handleOpenNotesDialog(
                        this.state.templates.indexOf(row)
                      );
                    }}
                  >
                    <TextSnippetIcon fontSize="small" color="action" />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          </TableCell>

          <TableCell onClick={navigateToLinked} style={{ padding: '0', margin: '0', cursor, ...linkStyle }}>
            {this.formatDate(row.date)}
          </TableCell>

          <TableCell
            onClick={navigateToLinked}
            style={{
              textAlign: 'right',
              padding: '5px',
              paddingRight: '50px',
              width: 'auto',
              cursor,
              ...linkStyle,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
              }}
            >
              {this.renderEntryDescription(row)}
            </div>
          </TableCell>

          <TableCell
            onClick={navigateToLinked}
            style={{
              textAlign: 'right',
              padding: '5px',
              paddingRight: '50px',
              width: 'auto',
              cursor,
              ...linkStyle,
            }}
          >
            {this.formatBalance(row.debit) !== '0.00' && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                <span style={{ flexShrink: 0 }}>$</span>
                <span
                  style={{
                    marginLeft: '55px',
                    minWidth: '80px',
                    textAlign: 'right',
                  }}
                >
                  {this.formatBalance(row.debit)}
                </span>
              </div>
            )}
          </TableCell>

          <TableCell
            onClick={navigateToLinked}
            style={{
              textAlign: 'right',
              padding: '5px',
              paddingRight: '50px',
              width: 'auto',
              cursor,
              ...linkStyle,
            }}
          >
            {this.formatBalance(row.credit) !== '0.00' && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                }}
              >
                <span style={{ flexShrink: 0 }}>$</span>
                <span
                  style={{
                    marginLeft: '55px',
                    minWidth: '80px',
                    textAlign: 'right',
                  }}
                >
                  {this.formatBalance(row.credit)}
                </span>
              </div>
            )}
          </TableCell>

          <TableCell
            onClick={navigateToLinked}
            style={{
              textAlign: 'right',
              padding: '5px',
              paddingRight: '50px',
              width: 'auto',
              cursor,
              ...linkStyle,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'left',
              }}
            >
              <span style={{ flexShrink: 0 }}>$</span>
              <span
                style={{
                  marginLeft: '55px',
                  minWidth: '80px',
                  textAlign: 'right',
                }}
              >
                {this.formatBalance(row.balance)}
              </span>
            </div>
          </TableCell>
        </React.Fragment>
      );
    };

    getTotal = () => {

        const totals = this.state.templates.reduce(
          (acc, entry) => {
              const credit = parseFloat(entry.credit) || 0; // Convert credit to a number
              const debit = parseFloat(entry.debit) || 0; // Convert credit to a number
              if (entry.description === 'Cost of Sales' ||
                entry.description === 'Accounts Payable' || entry.description === 'Sales'  ) {
                  acc.costOfSalesTotal += credit;
              }else if(entry.description === 'Accounts Receivables' || entry.description === 'Cash'){
                  acc.costOfSalesTotal += debit;
              }else {
                  acc.otherTotal += credit;
              }
              return acc;
          },
          { costOfSalesTotal: 0, otherTotal: 0 } // Initial accumulator values
        );

        const grandTotal = totals.costOfSalesTotal + totals.otherTotal; // Combine totals
        return { ...totals, grandTotal }; // Return both individual totals and grand total
    };

    handleOpenFetch = () => {
        this.setState({
            isDialogFetch: true,
        });
    };

    // Custom ledger refresh — fetch the recomputed entries WITHOUT persisting, then open
    // the audit preview. The current entries are captured as the "before" baseline.
    handleRefresh=()=>{
        const data = {
            ledgerId: this.props.ledger.ledgerId,
            year: this.props.selectedYear,
            currency: this.props.selectedCurrency
        }

        const oldTemplates = [...this.state.templates];

        this.setState({ isAuditPreviewOpen: true, previewEntries: null, previewOldTemplates: oldTemplates });

        const callback = (error, response) => {
            if (response) {
                this.setState({ previewEntries: response });
            } else {
                this.setState({ isAuditPreviewOpen: false });
            }
            this.handleCloseFetch();
        };

        this.props.fetchTransactionsLedger(data, callback, true)
    }

    handleCloseFetch= () => {
        this.setState({
            isDialogFetch: false,
        });
    };

    // Predefined ledger refresh — request a non-persisting preview snapshot from the server.
    handleOpenAuditPreview = () => {
        this.props.clearLedgerPreview();
        this.setState({ isAuditPreviewOpen: true, previewEntries: null });
        this.props.previewLedgerRefresh({
            ledgerId: this.props.ledger.ledgerId,
            year: this.props.selectedYear,
            currency: this.props.selectedCurrency,
        });
    };

    handleApplyPreview = () => {
        const { ledger, selectedYear, selectedCurrency } = this.props;
        if (this.state.isShowPayable) {
            // Predefined — persist the exact previewed snapshot.
            if (this.props.ledgerPreview) {
                this.props.applyLedgerRefresh({
                    ledgerId: ledger.ledgerId,
                    year: selectedYear,
                    currency: selectedCurrency,
                    snapshot: this.props.ledgerPreview,
                });
            }
        } else if (this.state.previewEntries) {
            // Custom — commit the fetched entries via the existing save path.
            this.props.handleSave(this.state.previewEntries, ledger.ledgerId);
        }
        // This ledger is now in sync — clear its desync indicator on the list.
        if (this.props.clearLedgerDesyncEntry) {
            this.props.clearLedgerDesyncEntry(ledger.ledgerId);
        }
        this.setState({ isAuditPreviewOpen: false, previewEntries: null, previewOldTemplates: null });
    };

    handleRejectPreview = () => {
        this.props.clearLedgerPreview();
        this.setState({ isAuditPreviewOpen: false, previewEntries: null, previewOldTemplates: null });
    };

    buildPreviewData = () => {
        const isPredefined = this.state.isShowPayable;
        const previewNew = isPredefined
            ? this.props.ledgerPreview
            : (this.state.previewEntries ? { ledgerEntries: this.state.previewEntries } : null);
        const previewLoading = isPredefined
            ? !this.props.ledgerPreview
            : (this.state.isAuditPreviewOpen && !this.state.previewEntries);
        const oldData = isPredefined
            ? {
                carrierSummary: this.state.carrierSummary,
                supplierSummary: this.state.supplierSummary,
                ftlSummary: this.state.ftlSummary,
                marketplaceSummary: this.state.marketplaceSummary,
                customerSummary: this.state.customerSummary,
                stockSummary: this.state.stockSummary,
                salesSummary: this.state.salesSummary,
                bankAccountSummary: this.state.bankAccountSummary,
                outstandingChequesSummary: this.state.outstandingChequesSummary,
                creditCardBalancesSummary: this.state.creditCardBalancesSummary,
                templates: this.state.templates,
            }
            : { templates: this.state.previewOldTemplates || this.state.templates };
        const diff = (this.state.isAuditPreviewOpen && previewNew)
            ? buildLedgerDiff(this.props.ledger.name, oldData, previewNew)
            : null;
        return { previewLoading, diff };
    };

    handleOpenMarketplaceNotesDialog = (index) => {

        this.setState({
            isMarketplaceDialog: true,
            currentMarketplaceNote: this.state.marketplaceEntries[index].note || '',
            selectedMarketplaceIndex: index,
        });
    };

    handleCloseMarketplaceNotesDialog = () => {
        this.setState({
            isMarketplaceDialog: false,
            currentMarketplaceNote: '',
            selectedMarketplaceIndex: null,
        });
    };

    handleOpenViewMarketplaceNoteDialog = (note) => {
        this.setState({
            isViewMarketplaceNoteDialog: true,
            currentViewMarketplaceNote: note || '',
        });
    };

    handleCloseViewMarketplaceNoteDialog = () => {
        this.setState({
            isViewMarketplaceNoteDialog: false,
            currentViewMarketplaceNote: '',
        });
    };

    handleOpenNotesDialog = (index) => {
        this.setState({
            isDialogOpen: true,
            currentNote: this.state.templates[index].note || '',
            selectedIndex: index,
        });
    };

    handleCloseNotesDialog = () => {
        this.setState({
            isDialogOpen: false,
            currentNote: '',
            selectedIndex: null,
        });
    };

    handleSaveNote = () => {
        const { selectedIndex, currentNote, templates } = this.state;
        if (selectedIndex !== null) {
            const updatedTemplates = [...templates];
            updatedTemplates[selectedIndex].note = currentNote;
            this.setState({ templates: updatedTemplates, isDialogOpen: false, currentNote: '', selectedIndex: null },()=>{
                this.props.handleSave(this.state.templates, this.props.ledger.ledgerId);
            });
        }


    };

    handleSaveMarketplaceNote = () => {
        const { selectedMarketplaceIndex, currentMarketplaceNote, marketplaceEntries } = this.state;
        if (selectedMarketplaceIndex !== null) {
            const updatedTemplates = [...marketplaceEntries];
            updatedTemplates[selectedMarketplaceIndex].note = currentMarketplaceNote;
            this.setState({marketplaceEntries: updatedTemplates,isMarketplaceDialog : false, currentMarketplaceNote: '', selectedMarketplaceIndex: null },()=>{
                    this.handleMarketplaceEntriesSave()
            });
        }


    };

    handleOpenSummaryNotesDialog = (currentNote, onSave) => {
        this.setState({
            isSummaryNotesDialog: true,
            currentSummaryNote: currentNote || '',
            summarySaveCallback: onSave,
        });
    };

    handleCloseSummaryNotesDialog = () => {
        this.setState({
            isSummaryNotesDialog: false,
            currentSummaryNote: '',
            summarySaveCallback: null,
        });
    };

    handleSaveSummaryNote = () => {
        const { currentSummaryNote, summarySaveCallback } = this.state;
        if (typeof summarySaveCallback === 'function') {
            summarySaveCallback(currentSummaryNote);
        }
        this.setState({
            isSummaryNotesDialog: false,
            currentSummaryNote: '',
            summarySaveCallback: null,
        });
    };

    render() {

        const {isDialogOpen, currentNote,} = this.state;
        const pageName = this.state.isShowMarketplaceDetails
          ? `Ledger - ${this.props.ledger.name} (${MARKETPLACE_MAPPING[this.state.selectedMarketplace.name] ?? this.state.selectedMarketplace.name})`
          : `Ledger - ${this.props.ledger.name}`;

        const { previewLoading, diff } = this.buildPreviewData();

        return (
          <React.Fragment>
            <TopToolbar
              pageName={pageName}
              menuItems={this.getContextualMenuItems()}
            />

            <LedgerAuditPreviewDialog
              open={this.state.isAuditPreviewOpen}
              loading={previewLoading}
              ledgerName={this.props.ledger.name}
              diff={diff}
              onApply={this.handleApplyPreview}
              onReject={this.handleRejectPreview}
            />

              <Dialog open={this.state.isDialogFetch} onClose={this.handleCloseFetch}>
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent>
                      <DialogContentText>
                          Existing entries (except for manual entries) will be deleted and re-fetched from the source. Would you like to continue?
                      </DialogContentText>
                  </DialogContent>
                  <DialogActions>

                      <div className='save-cancel-buttons' style={{marginRight:'16px'}}>
                          <Button
                            variant='contained'
                            onClick={this.handleCloseFetch}
                          >
                              No
                          </Button>

                          <div className='save-spacing'/>
                          <Button
                            variant='contained'
                            color='primary'
                            onClick={this.handleRefresh}
                          >
                              Yes
                          </Button>
                      </div>

                  </DialogActions>
              </Dialog>

            <Dialog open={isDialogOpen} onClose={this.handleCloseNotesDialog}>
              <DialogTitle>Edit Note</DialogTitle>
              <DialogContentText style={{ width: '500px' }}></DialogContentText>
              <DialogContent>
                <TextField
                  label="Note"
                  multiline
                  minRows={4}
                  variant="outlined"
                  fullWidth
                  value={currentNote}
                  onChange={(e) =>
                    this.setState({ currentNote: e.target.value })
                  }
                />
              </DialogContent>
              <DialogActions style={{ marginBottom: '16px' }}>
                <Button
                  variant="contained"
                  onClick={this.handleCloseNotesDialog}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleSaveNote}
                  style={{ marginLeft: '16px', marginRight: '16px' }}
                >
                  Save
                </Button>
              </DialogActions>
            </Dialog>



              <Dialog open={this.state.isViewMarketplaceNoteDialog} onClose={this.handleCloseViewMarketplaceNoteDialog}>
                  <DialogTitle>Note</DialogTitle>
                  <DialogContentText style={{ width: '500px' }}></DialogContentText>
                  <DialogContent>
                      <TextField
                        label="Note"
                        multiline
                        minRows={4}
                        variant="outlined"
                        fullWidth
                        value={this.state.currentViewMarketplaceNote}
                        InputProps={{ readOnly: true }}
                      />
                  </DialogContent>
                  <DialogActions style={{ marginBottom: '16px' }}>
                      <Button
                        variant="contained"
                        onClick={this.handleCloseViewMarketplaceNoteDialog}
                        style={{ marginRight: '16px' }}
                      >
                          Close
                      </Button>
                  </DialogActions>
              </Dialog>

              <Dialog open={this.state.isMarketplaceDialog} onClose={this.handleCloseMarketplaceNotesDialog}>
                  <DialogTitle>Edit Note</DialogTitle>
                  <DialogContentText style={{ width: '500px' }}></DialogContentText>
                  <DialogContent>
                      <TextField
                        label="Note"
                        multiline
                        minRows={4}
                        variant="outlined"
                        fullWidth
                        value={this.state.currentMarketplaceNote}
                        onChange={(e) =>
                          this.setState({ currentMarketplaceNote: e.target.value })
                        }
                      />
                  </DialogContent>
                  <DialogActions style={{ marginBottom: '16px' }}>
                      <Button
                        variant="contained"
                        onClick={this.handleCloseMarketplaceNotesDialog}
                      >
                          Cancel
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleSaveMarketplaceNote}
                        style={{ marginLeft: '16px', marginRight: '16px' }}
                      >
                          Save
                      </Button>
                  </DialogActions>
              </Dialog>

              <Dialog open={this.state.isSummaryNotesDialog} onClose={this.handleCloseSummaryNotesDialog}>
                  <DialogTitle>Edit Note</DialogTitle>
                  <DialogContentText style={{ width: '500px' }}></DialogContentText>
                  <DialogContent>
                      <TextField
                        label="Note"
                        multiline
                        minRows={4}
                        variant="outlined"
                        fullWidth
                        value={this.state.currentSummaryNote}
                        onChange={(e) =>
                          this.setState({ currentSummaryNote: e.target.value })
                        }
                      />
                  </DialogContent>
                  <DialogActions style={{ marginBottom: '16px' }}>
                      <Button
                        variant="contained"
                        onClick={this.handleCloseSummaryNotesDialog}
                      >
                          Cancel
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleSaveSummaryNote}
                        style={{ marginLeft: '16px', marginRight: '16px' }}
                      >
                          Save
                      </Button>
                  </DialogActions>
              </Dialog>

            {!this.state.isShowMarketplaceDetails && (
              <Box className="box-ledger">
                <FormControl variant="outlined" className="form-control-ledger">
                  <InputLabel id="year-label">Year</InputLabel>
                  <Select
                    className="select-year-ledger"
                    labelId="year-label"
                    value={this.props.selectedYear}
                    onChange={this.props.handleYearChange}
                    label="Year"
                  >
                    {this.props.years.map((year) => (
                      <MenuItem key={year} value={year}>
                        {year}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl variant="outlined" className="form-control">
                  <InputLabel id="year-label">Currency</InputLabel>
                  <Select
                    className="select-currency-ledger"
                    labelId="currency-label"
                    value={this.props.selectedCurrency}
                    onChange={this.props.handleChange}
                    label="Currency"
                  >
                    {this.props.currency.map((currency) => (
                      <MenuItem key={currency} value={currency}>
                        {currency}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            )}

            {(this.props.ledger.name === 'Cost of Sales' ||
              this.props.ledger.name === 'Accounts Receivables' ||
              this.props.ledger.name === 'Cash' ||
              this.props.ledger.name === 'Accounts Payable') ||
              this.props.ledger.name === 'Sales' &&
              this.props.selectedCurrency !== 'Consolidated CAD' &&
              !this.state.isShowMarketplaceDetails && (
                <div style={{ marginLeft: '32px' }}>
                  Last updated: {Utils.formatDateTime(this.props.lastUpdated)}
                </div>
              )}

            {this.state.isEditMarketplace && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'left',
                  marginTop: '16px',
                  marginLeft: '24px',
                  marginRight: '24px',
                }}
              >
                <div className="transaction-form-section">
                  {this.state.marketplaceEntries.map((template, index) => {
                    const isWalmartMarketplace = ['walmart_ca', 'walmart_com'].includes(this.state.selectedMarketplace?.name);
                    const FIXED_SUMMARY_ROWS = ['Income (Gross Sales)', 'Net Tax Received', 'Total Expenses'];
                    const isOpeningBalance = template.description === 'Opening Balance';
                    const isFixedSummaryRow = FIXED_SUMMARY_ROWS.includes(template.description);
                    const isRemittance = template.description === 'Remittance';
                    const isLockedSummaryRow = isFixedSummaryRow || (isRemittance && !isWalmartMarketplace);
                    const isEditableSourceRow = !isOpeningBalance && !isLockedSummaryRow;
                    const isFromTransactions = isEditableSourceRow && template.source === 'Transactions';
                    return (
                    <React.Fragment key={index}>
                    <div
                      className="transaction-form-details"
                      draggable={
                        ![
                          'Opening Balance',
                          'Income (Gross Sales)',
                          'Net Tax Received',
                          'Total Expenses',
                          'Remittance',
                        ].includes(template.description)
                      }
                      onDragStart={() => {
                        if (
                          ![
                            'Opening Balance',
                            'Income (Gross Sales)',
                            'Net Tax Received',
                            'Total Expenses',
                            'Remittance',
                          ].includes(template.description)
                        ) {
                          this.onDragStart(index);
                        }
                      }}
                      onDragOver={(e) => {
                        const restrictedDescriptions = [
                          'Opening Balance',
                          'Income (Gross Sales)',
                          'Net Tax Received',
                          'Total Expenses',
                          'Remittance',
                        ];
                        // Prevent dragging over restricted items
                        if (
                          !restrictedDescriptions.includes(template.description)
                        ) {
                          this.onDragMarketplaceOver(index);
                        }
                        e.preventDefault();
                      }}
                      onDragEnd={this.onDragEnd}
                      style={{
                        justifyContent: 'flex-start',
                        background:
                          this.state.draggedIndex === index
                            ? '#f0f0f0'
                            : 'white',
                      }}
                    >
                      <div style={{ width: '6%', display: 'flex', alignItems: 'center' }}>
                        {[
                          'Opening Balance',
                          'Income (Gross Sales)',
                          'Net Tax Received',
                          'Total Expenses',
                          'Remittance',
                        ].includes(template.description) ? (
                          <IconButton style={{ visibility: 'hidden' }}>
                            <RemoveCircleIcon fontSize="small" />
                          </IconButton>
                        ) : (
                          <Tooltip title={'Remove Entry'}>
                            <IconButton
                              onClick={() => this.removeMarketplaceRow(index)}
                            >
                              <RemoveCircleIcon fontSize="small" color="error" />
                            </IconButton>
                          </Tooltip>
                        )}

                          <Tooltip title={'Notes'}>
                              {template.note ? (
                                <IconButton
                                  onClick={() => this.handleOpenMarketplaceNotesDialog(index)}
                                >
                                    <TextSnippetIcon fontSize="small" />
                                </IconButton>
                              ) : (
                                <IconButton
                                  onClick={() => this.handleOpenMarketplaceNotesDialog(index)}
                                >
                                    <TextSnippetOutlinedIcon fontSize="small" />
                                </IconButton>
                              )}
                          </Tooltip>

                        {template.transactionId === null && (
                          <div className="ledger-circle-icon" style={{ marginTop: 0 }}>M</div>
                        )}
                      </div>


                      <TextField
                        variant="outlined"
                        name="description"
                        label="Description"
                        style={{ width: '16%', marginLeft: '8px' }}
                        InputLabelProps={{ shrink: true }}
                        value={template.description || ''}
                        onChange={(e) =>
                          this.handleMarketplaceChange(
                            {
                              target: {
                                name: 'description',
                                value: e.target.value,
                              },
                            },
                            index,
                            template
                          )
                        }
                        required
                        InputProps={{
                          readOnly: [
                            'Opening Balance',
                            'Income (Gross Sales)',
                            'Net Tax Received',
                            'Total Expenses',
                            'Remittance',
                          ].includes(template.description),
                        }}
                        error={!template.description}
                      />

                      <TextField
                        variant="outlined"
                        name="debit"
                        label="Debit"
                        style={{ width: '9%' }}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                          inputProps: { style: { textAlign: 'right' } },
                        }}
                        value={this.formatAmount(template.debit)}
                        onChange={(e) =>
                          this.handleMarketplaceChange(
                            {
                              target: {
                                name: 'debit',
                                value: this.formatDollar(e.target.value),
                              },
                            },
                            index,
                            template
                          )
                        }
                        onBlur={(e) => this.handleMarketplaceBlur(e, index)}
                        required
                        error={
                          template.debit === null ||
                          template.debit === undefined ||
                          template.debit === ''
                        }
                      />

                      <TextField
                        variant="outlined"
                        name="credit"
                        label="Credit"
                        style={{ width: '9%' }}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                          inputProps: { style: { textAlign: 'right' } },
                          readOnly: isFromTransactions,
                        }}
                        value={this.formatAmount(template.credit)}
                        onChange={(e) =>
                          this.handleMarketplaceChange(
                            {
                              target: {
                                name: 'credit',
                                value: this.formatDollar(e.target.value),
                              },
                            },
                            index,
                            template
                          )
                        }
                        onBlur={(e) => this.handleMarketplaceBlur(e, index)}
                        required
                        error={
                          template.credit === null ||
                          template.credit === undefined ||
                          template.credit === ''
                        }
                      />

                      <TextField
                        variant="outlined"
                        name="balance"
                        style={{ width: '9%' }}
                        label="Balance"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                          inputProps: { style: { textAlign: 'right' } },
                        }}
                        value={this.formatAmount(template.balance)}
                        onChange={(e) =>
                          this.handleMarketplaceChange(
                            {
                              target: {
                                name: 'balance',
                                value: this.formatDollar(e.target.value),
                              },
                            },
                            index,
                            template
                          )
                        }
                        onBlur={(e) => this.handleMarketplaceBlur(e, index)}
                        required
                        error={!template.balance}
                      />

                      {isLockedSummaryRow ? (
                        <>
                          <Autocomplete
                            style={{ width: '14%' }}
                            disabled
                            options={['Marketplace Summary']}
                            getOptionLabel={(option) => option || ''}
                            value="Marketplace Summary"
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Source"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                              />
                            )}
                          />
                          <Autocomplete
                            style={{ width: '17%' }}
                            disabled
                            multiple
                            options={[template.description]}
                            getOptionLabel={(option) => option || ''}
                            value={[template.description]}
                            renderTags={(value) =>
                              value.map((option) => (
                                <Chip
                                  key={option}
                                  variant="outlined"
                                  size="small"
                                  style={{ borderColor: '#acd685', margin: '1px 6px 1px 0', fontSize: '12px' }}
                                  label={option}
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Category"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                  ...params.InputProps,
                                  style: {
                                    minHeight: 56,
                                    maxHeight: 56,
                                    flexWrap: 'nowrap',
                                    overflow: 'hidden',
                                  },
                                }}
                              />
                            )}
                          />
                          <div style={{ width: '12%' }} />
                        </>
                      ) : isEditableSourceRow ? (
                        <>
                          <Autocomplete
                            style={{ width: '14%' }}
                            options={['', 'Transactions']}
                            getOptionLabel={(option) => option || ''}
                            value={template.source || ''}
                            onChange={(e, value) => {
                              this.setState(prevState => {
                                const updatedTemplates = [...prevState.marketplaceEntries];
                                updatedTemplates[index] = {
                                  ...updatedTemplates[index],
                                  source: value || '',
                                  category: value === 'Transactions' ? (updatedTemplates[index].category || []) : [],
                                  sumRule: value === 'Transactions' ? (updatedTemplates[index].sumRule || '') : '',
                                };
                                return { marketplaceEntries: updatedTemplates };
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Source"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                              />
                            )}
                          />
                          {template.source === 'Transactions' ? (
                            <>
                              <Autocomplete
                                style={{ width: '17%' }}
                                multiple
                                options={(this.props.categories || []).slice().sort((a, b) => a.displayOrder - b.displayOrder)}
                                getOptionLabel={(option) => option.name || ''}
                                value={
                                  Array.isArray(template.category)
                                    ? template.category
                                        .map(cat => (this.props.categories || []).find(c => c.name === cat))
                                        .filter(Boolean)
                                    : []
                                }
                                renderTags={(value) => (
                                  <div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center', overflow: 'hidden', maxWidth: '100%', minWidth: 0 }}>
                                    {value.length > 1 ? (
                                      <>
                                        <Chip
                                          key={value[0].name}
                                          variant="outlined"
                                          size="small"
                                          style={{ borderColor: '#acd685', margin: '1px 6px 1px 0', fontSize: '12px', maxWidth: 'calc(100% - 50px)', minWidth: 0 }}
                                          label={value[0].name}
                                        />
                                        <Chip
                                          variant="outlined"
                                          size="small"
                                          style={{ borderColor: '#acd685', margin: '1px 6px 1px 0', fontSize: '12px', flexShrink: 0 }}
                                          label="..."
                                        />
                                      </>
                                    ) : (
                                      value.map((option) => (
                                        <Chip
                                          key={option.name}
                                          variant="outlined"
                                          size="small"
                                          style={{ borderColor: '#acd685', margin: '1px 6px 1px 0', fontSize: '12px', maxWidth: '100%', minWidth: 0 }}
                                          label={option.name}
                                        />
                                      ))
                                    )}
                                  </div>
                                )}
                                renderOption={(option, { selected }) => (
                                  <React.Fragment>
                                    <Checkbox
                                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                                      style={{ marginRight: 8 }}
                                      checked={selected}
                                    />
                                    {option.name}
                                  </React.Fragment>
                                )}
                                onChange={(event, value) => {
                                  this.setState(prevState => {
                                    const updatedTemplates = [...prevState.marketplaceEntries];
                                    updatedTemplates[index] = {
                                      ...updatedTemplates[index],
                                      category: value.map(cat => cat?.name).filter(Boolean),
                                    };
                                    return { marketplaceEntries: updatedTemplates };
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Category"
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{
                                      ...params.InputProps,
                                      style: {
                                        minHeight: 56,
                                        maxHeight: 56,
                                        flexWrap: 'nowrap',
                                        overflow: 'hidden',
                                      },
                                    }}
                                  />
                                )}
                              />
                              <Autocomplete
                                style={{ width: '12%' }}
                                options={SUM_RULE_OPTIONS}
                                getOptionLabel={(option) => option || ''}
                                value={template.sumRule || ''}
                                onChange={(e, value) => {
                                  this.setState(prevState => {
                                    const updatedTemplates = [...prevState.marketplaceEntries];
                                    updatedTemplates[index] = {
                                      ...updatedTemplates[index],
                                      sumRule: value || '',
                                    };
                                    return { marketplaceEntries: updatedTemplates };
                                  });
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Sum Rule"
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                  />
                                )}
                              />
                            </>
                          ) : (
                            <>
                              <div style={{ width: '17%' }} />
                              <div style={{ width: '12%' }} />
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <div style={{ width: '14%' }} />
                          <div style={{ width: '17%' }} />
                          <div style={{ width: '12%' }} />
                        </>
                      )}

                      <MenuIcon
                        style={{
                          cursor: 'grab',
                          marginLeft: 'auto',
                          opacity: '0.6',
                          alignSelf: 'center',
                          visibility: [
                            'Opening Balance',
                            'Income (Gross Sales)',
                            'Net Tax Received',
                            'Total Expenses',
                            'Remittance',
                          ].includes(template.description)
                            ? 'hidden'
                            : 'visible',
                        }}
                      />
                    </div>
                    </React.Fragment>
                    );
                  })}
                  <div style={{ marginTop: '20px' }}>
                    <IconButton onClick={() => this.addMarketplaceRow()}>
                      <AddCircleIcon fontSize="small" color="secondary" />
                    </IconButton>
                    {/*<IconButton onClick={() => this.fetchLedgerEntries()}>*/}
                    {/*  <RefreshIcon fontSize="small" color="green" />*/}
                    {/*</IconButton>*/}
                  </div>
                </div>
              </div>
            )}

            {this.state.isShowMarketplaceDetails &&
              !this.state.isEditMarketplace && (
                <div style={{ marginTop: '-50px' }}>
                  <TablePage
                    tableName="LedgerEntriesTable"
                    tableColumnHeads={this.getMarketplaceEntriesTableHeaders()}
                    tableRows={this.state.marketplaceEntries}
                    tableRow={(row, index, getRowState, setRowState) =>
                      this.getMarketplaceDetailsTableRow(
                        row,
                        getRowState,
                        setRowState
                      )
                    }
                    getRowId={(row) => row.transactionId}
                    paginationText="Marketplace entries per page"
                  />
                </div>
              )}

            {this.state.isShowMarketplaceDetails ? null : this.state
                .isEditEntries ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'left',
                  marginTop: '16px',
                  marginLeft: '24px',
                  marginRight: '24px',
                }}
              >
                <div className="transaction-form-section">
                  {this.state.templates.map((template, index) => {

                        const isOpeningBalance = template.description === 'Opening Balance' && !!template.transactionId;
                        const isDisabled = !!template.journalEntryId;
                        const canDrag = !isDisabled && !isOpeningBalance;

                        const isReservedError = !template.transactionId && !template.journalEntryId && template.description?.trim().toLowerCase() === 'opening balance';

                        return (
                          <div
                            className="transaction-form-details"
                            key={index}
                            draggable={canDrag}
                            onDragStart={() => canDrag && this.onDragStart(index)}
                            onDragOver={(e) => {
                                const isOpeningBalance = template.description === 'Opening Balance';
                                if (!isDisabled && !isOpeningBalance) {
                                    this.onDragOver(index);
                                    e.preventDefault();
                                }
                            }}
                            onDragEnd={() => canDrag && this.onDragEnd()}
                            style={{
                                background:
                                  this.state.draggedIndex === index ? '#f0f0f0' : 'white',
                                opacity: isDisabled ? 0.6 : 1,
                            }}
                          >
                              <div style={{ width: '7%', display: 'flex' , marginTop: isReservedError ? '-32px' : '0'}}>
                                  <Tooltip title={'Remove Entry'}>
                                      <IconButton
                                        onClick={() => this.removeTemplateRow(index)}
                                        disabled={isDisabled}
                                      >
                                          <RemoveCircleIcon fontSize="small" color="error" />
                                      </IconButton>
                                  </Tooltip>
                                  <Tooltip title={'Notes'} >
                                      {this.state.templates[index].note ? (
                                        <IconButton
                                          onClick={() => this.handleOpenNotesDialog(index)}
                                        >
                                            <TextSnippetIcon fontSize="small" />
                                        </IconButton>
                                      ) : (
                                        <IconButton
                                          onClick={() => this.handleOpenNotesDialog(index)}
                                        >
                                            <TextSnippetOutlinedIcon fontSize="small" />
                                        </IconButton>
                                      )}
                                  </Tooltip>


                                  {template.journalEntryId ? (
                                      <div className="ledger-circle-icon" style={{marginTop: isReservedError ? '50px' : '18px'}}>J</div>
                                    ) :
                                    template.transactionId === null && (
                                      <div className="ledger-circle-icon" style={{marginTop: isReservedError ? '50px' : '18px'}}>M</div>
                                    )
                                  }



                              </div>

                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                  <KeyboardDatePicker
                                    disabled={isDisabled || isOpeningBalance}
                                    name="date"
                                    label="Date"
                                    value={template.date}
                                    onChange={(date) => {
                                        if (!date || isNaN(date.getTime())) {
                                            return;
                                        }

                                        const options = {
                                            timeZone: 'UTC',
                                            year: 'numeric',
                                            month: '2-digit',
                                            day: '2-digit',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            second: '2-digit',
                                            hour12: false,
                                        };
                                        const formatter = new Intl.DateTimeFormat(
                                          'en-CA',
                                          options
                                        );
                                        const parts = formatter.formatToParts(date);
                                        const formattedDate = `${
                                          parts.find((p) => p.type === 'year')
                                            .value
                                        }-${
                                          parts.find((p) => p.type === 'month')
                                            .value
                                        }-${
                                          parts.find((p) => p.type === 'day')
                                            .value
                                        }T${
                                          parts.find((p) => p.type === 'hour')
                                            .value
                                        }:${
                                          parts.find((p) => p.type === 'minute')
                                            .value
                                        }:${
                                          parts.find((p) => p.type === 'second')
                                            .value
                                        }.000Z`;

                                        this.handleTemplateDateChange(
                                          formattedDate,
                                          index,
                                          template
                                        );
                                    }}
                                    format="yyyy-MM-dd"
                                    variant="inline"
                                    inputVariant="outlined"
                                    style={{ width: '15%' }}
                                    autoOk
                                    required
                                  />
                              </MuiPickersUtilsProvider>
                              <div
                                  style={{
                                    width: '300px',
                                    maxWidth: '25%'
                                  }}
                                >
                                  <TextField
                                    fullWidth
                                    disabled={isDisabled || isOpeningBalance}
                                    variant="outlined"
                                    name="description"
                                    label="Description"
                                    InputLabelProps={{ shrink: true }}
                                    value={template.description || ''}
                                    onChange={(e) =>
                                      this.handleTemplateChange(
                                        {
                                          target: {
                                            name: 'description',
                                            value: e.target.value,
                                          },
                                        },
                                        index,
                                        template
                                      )
                                    }
                                    error={!template.description || isReservedError}
                                  />
                                  {isReservedError && (
                                    <div
                                      style={{
                                        color: '#f44336',
                                        fontSize: '0.75rem',
                                        marginTop: '4px',
                                        width: '100%',
                                        display: 'block',
                                        overflowWrap: 'anywhere',
                                        lineHeight: '1.2',
                                        textAlign: 'left',
                                        marginLeft:'8px'
                                      }}
                                    >
                                      It can not be used as the description as this is the reserved field for carry forward balance
                                    </div>
                                  )}
                              </div>

                              <TextField
                                disabled={isDisabled || isOpeningBalance}
                                variant="outlined"
                                name="debit"
                                label="Debit"
                                style={{ width: '15%' }}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">$</InputAdornment>
                                    ),
                                    inputProps: { style: { textAlign: 'right' } },
                                }}
                                value={this.formatAmount(template.debit)}
                                onChange={(e) =>
                                  this.handleTemplateChange(
                                    {
                                        target: {
                                            name: 'debit',
                                            value: this.formatDollar(e.target.value),
                                        },
                                    },
                                    index,
                                    template
                                  )
                                }
                                onBlur={(e) => this.handleBlur(e, index)}
                                required
                                error={!template.debit}
                              />

                              <TextField
                                disabled={isDisabled || isOpeningBalance}
                                variant="outlined"
                                name="credit"
                                label="Credit"
                                style={{ width: '15%' }}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">$</InputAdornment>
                                    ),
                                    inputProps: { style: { textAlign: 'right' } },
                                }}
                                value={this.formatAmount(template.credit)}
                                onChange={(e) =>
                                  this.handleTemplateChange(
                                    {
                                        target: {
                                            name: 'credit',
                                            value: this.formatDollar(e.target.value),
                                        },
                                    },
                                    index,
                                    template
                                  )
                                }
                                onBlur={(e) => this.handleBlur(e, index)}
                                required
                                error={!template.credit}
                              />

                              <TextField
                                disabled={isDisabled}
                                variant="outlined"
                                name="balance"
                                style={{ width: '15%' }}
                                label="Balance"
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">$</InputAdornment>
                                    ),
                                    inputProps: { style: { textAlign: 'right' } },
                                }}
                                value={this.formatAmount(template.balance)}
                                onChange={(e) =>
                                  this.handleTemplateChange(
                                    {
                                        target: {
                                            name: 'balance',
                                            value: this.formatDollar(e.target.value),
                                        },
                                    },
                                    index,
                                    template
                                  )
                                }
                                onBlur={(e) => this.handleBlur(e, index)}
                                required
                                error={!template.balance}
                              />

                              <MenuIcon
                                style={{
                                    cursor: isDisabled ? 'not-allowed' : 'grab',
                                    marginLeft: '8px',
                                    opacity: '0.6',
                                    alignSelf: 'center',
                                    marginTop:  isReservedError ? "-32px" : '0'
                                }}
                              />
                          </div>

                        )
                    }
                  )}

                  <div style={{ marginTop: '30px' }}>
                    <IconButton onClick={() => this.addTemplateRow()}>
                      <AddCircleIcon fontSize="small" color="secondary" />
                    </IconButton>
                    <IconButton onClick={() => this.fetchLedgerEntries()}>
                      <RefreshIcon fontSize="small" color="green" />
                    </IconButton>
                  </div>
                </div>
              </div>
            ) : this.props.ledger.name !== 'Accounts Payable' &&
              this.props.ledger.name !== 'Accounts Receivables' &&
              this.props.ledger.name !== 'Cash' &&
              this.props.ledger.name !== 'Cost of Sales' &&
              this.props.ledger.name !==  'Sales' ? (
              <div style={{ marginTop: '-7px' }}>
                <TablePage
                  tableName="LedgerEntriesTable"
                  tableColumnHeads={this.getTableHeaders()}
                  tableRows={this.state.templates}
                  tableRow={(row, index, getRowState, setRowState) =>
                    this.getTableRow(row, getRowState, setRowState)
                  }
                  getRowId={(row) => row.transactionId}
                  paginationText="Ledgers entries per page"
                />
              </div>
            ) : (
              <div style={{ marginTop: '24px', marginBottom: '50px' }}>
                {this.sectionAllowed('stock') && (
                    <div className="ledger-fixed-table" style={{ marginTop: '-40px', marginBottom: '24px' }}>
                      <TablePage
                        type={'stockLedger'}
                        tableName="stockLedger"
                        tableColumnHeads={this.getStockTableHeaders()}
                        tableRows={this.state.stockSummary}
                        tableRow={(row, index, getRowState, setRowState) =>
                          this.getStockTableRow(row, getRowState, setRowState)
                        }
                        getRowId={(row) => row.id}
                      />
                    </div>
                  )}

                {this.sectionAllowed('creditCardBalances') && (
                      <div className="ledger-fixed-table" style={{ marginTop: '-40px', marginBottom: '24px' }}>
                          <TablePage
                            type={'customerLedger'}
                            tableName="BankAccount"
                            tableColumnHeads={this.getCreditCardBalancesTableHeaders()}
                            tableRows={this.state.creditCardBalancesSummary}
                            tableRow={(row, index, getRowState, setRowState) =>
                              this.getCreditCardBalancesTableRow(
                                row,
                                getRowState,
                                setRowState
                              )
                            }
                            getRowId={(row) => row.id}
                            defaultSortBy={'name'}
                          />

                          {this.state.isEditPayable && (
                            <div style={{ marginTop: '-18px' }}>
                                <div className="divider-ledger" />
                                <Tooltip
                                  title="Add Bank Account"
                                  style={{ marginLeft: '0px', marginTop: '8px' }}
                                >
                                    <IconButton
                                      onClick={() => {
                                          this.setState(
                                            { listingIdBeingEdited: '' },
                                            () => {
                                                const newEntry = [
                                                    ...this.state.creditCardBalancesSummary,
                                                    {
                                                        id: '',
                                                        name: '',
                                                        totalBalance: '',
                                                    },
                                                ];
                                                this.setState({
                                                    creditCardBalancesSummary: newEntry,
                                                });
                                            }
                                          );
                                      }}
                                      disabled={this.state.creditCardBalancesSummary.some(
                                        (acc) => acc.id === ''
                                      )}
                                    >
                                        <AddCircleIcon
                                          fontSize="small"
                                          color="secondary"
                                        />
                                    </IconButton>
                                </Tooltip>
                            </div>
                          )}
                      </div>
                    )
                }


                {this.sectionAllowed('carrier') && (
                    <div className="ledger-fixed-table" style={{ marginTop: '-40px', marginBottom: '24px' }}>
                      <TablePage
                        type={'carrierLedger'}
                        tableName="standardCarrier"
                        tableColumnHeads={this.getCarrierTableHeaders()}
                        defaultSortBy={'carrierName'}
                        tableRows={this.state.carrierSummary}
                        tableRow={(row, index, getRowState, setRowState) =>
                          this.getCarrierTableRow(row, getRowState, setRowState)
                        }
                        getRowId={(row) => row.id}
                      />

                      {this.state.isEditPayable && (
                        <div style={{ marginTop: '-18px' }}>
                          <div className="divider-ledger" />
                          <Tooltip
                            title="Add Standard Carrier"
                            style={{ marginLeft: '16px', marginTop: '8px' }}
                          >
                            <IconButton
                              onClick={() => {
                                this.setState(
                                  { listingIdBeingEdited: '' },
                                  () => {
                                    const newCarrierEntry = [
                                      ...this.state.carrierSummary,
                                      {
                                        id: '',
                                        carrierName: '',
                                        CY_SUBTOTAL_PAYABLE: '',
                                      },
                                    ];
                                    this.setState({
                                      carrierSummary: newCarrierEntry,
                                    });
                                  }
                                );
                              }}
                              disabled={this.state.carrierSummary.some(
                                (carrier) => carrier.id === ''
                              )}
                            >
                              <AddCircleIcon
                                fontSize="small"
                                color="secondary"
                              />
                            </IconButton>
                          </Tooltip>
                        </div>
                      )}
                    </div>
                  )}

                {this.sectionAllowed('ftl') && (
                  <div className="ledger-fixed-table" style={{ marginTop: '-40px', marginBottom: '24px' }}>
                    <TablePage
                      defaultSortBy={'carrierName'}
                      type={'ftlLedger'}
                      tableName="FTLCarrier"
                      tableColumnHeads={this.getFTLTableHeaders()}
                      tableRows={this.state.ftlSummary}
                      tableRow={(row, index, getRowState, setRowState) =>
                        this.getFTLTableRow(row, getRowState, setRowState)
                      }
                      getRowId={(row) => row.id}
                    />

                    {this.state.isEditPayable && (
                      <div style={{ marginTop: '-18px' }}>
                        <div className="divider-ledger" />
                        <Tooltip
                          title="Add LTL/FTL Carrier"
                          style={{ marginLeft: '16px', marginTop: '8px' }}
                        >
                          <IconButton
                            onClick={() => {
                              this.setState(
                                { listingIdBeingEdited: '' },
                                () => {
                                  const newEntry = [
                                    ...this.state.ftlSummary,
                                    {
                                      id: '',
                                      carrierName: '',
                                      CY_SUBTOTAL_PAYABLE: '',
                                    },
                                  ];
                                  this.setState({ ftlSummary: newEntry });
                                }
                              );
                            }}
                            disabled={this.state.ftlSummary.some(
                              (carrier) => carrier.id === ''
                            )}
                          >
                            <AddCircleIcon fontSize="small" color="secondary" />
                          </IconButton>
                        </Tooltip>
                      </div>
                    )}
                  </div>
                )}

                {this.sectionAllowed('supplier') && (
                    <div className="ledger-fixed-table" style={{ marginTop: '-40px', marginBottom: '24px' }}>
                      <TablePage
                        type={'supplierLedger'}
                        tableName="Supplier"
                        tableColumnHeads={this.getSupplierTableHeaders()}
                        tableRows={this.state.supplierSummary}
                        tableRow={(row, index, getRowState, setRowState) =>
                          this.getSupplierTableRow(
                            row,
                            getRowState,
                            setRowState
                          )
                        }
                        getRowId={(row) => row.id}
                        defaultSortBy={'supplierName'}
                      />

                      {this.state.isEditPayable && (
                        <div style={{ marginTop: '-18px' }}>
                          <div className="divider-ledger" />
                          <Tooltip
                            title="Add Supplier"
                            style={{ marginLeft: '16px', marginTop: '8px' }}
                          >
                            <IconButton
                              onClick={() => {
                                this.setState(
                                  { listingIdBeingEdited: '' },
                                  () => {
                                    const newEntry = [
                                      ...this.state.supplierSummary,
                                      {
                                        id: '',
                                        supplierName: '',
                                        CY_SUBTOTAL_PAYABLE: '',
                                      },
                                    ];
                                    this.setState({
                                      supplierSummary: newEntry,
                                    });
                                  }
                                );
                              }}
                              disabled={this.state.supplierSummary.some(
                                (supplier) => supplier.id === ''
                              )}
                            >
                              <AddCircleIcon
                                fontSize="small"
                                color="secondary"
                              />
                            </IconButton>
                          </Tooltip>
                        </div>
                      )}
                    </div>
                  )}

                {this.sectionAllowed('marketplace') && (
                    <div className="ledger-fixed-table" style={{ marginTop: '-40px', marginBottom: '24px' }}>
                      <TablePage
                        defaultSortBy={'marketplace'}
                        type={'marketplaceLedger'}
                        tableName="MarketplaceSummary"
                        tableColumnHeads={this.getMarketplaceTableHeaders()}
                        tableRows={this.state.marketplaceSummary}
                        tableRow={(row, index, getRowState, setRowState) =>
                          this.getMarketplaceTableRow(
                            row,
                            getRowState,
                            setRowState
                          )
                        }
                        getRowId={(row) => row.id}
                      />

                      {this.state.isEditPayable && (
                        <div style={{ marginTop: '-18px' }}>
                          <div className="divider-ledger" />
                          <Tooltip
                            title="Add Marketplace"
                            style={{ marginLeft: '0px', marginTop: '8px' }}
                          >
                            <IconButton
                              onClick={() => {
                                this.setState(
                                  { listingIdBeingEdited: '' },
                                  () => {
                                    const newEntry = [
                                      ...this.state.marketplaceSummary,
                                      {
                                        id: '',
                                        marketplace: '',
                                        amount: '',
                                      },
                                    ];
                                    this.setState({
                                      marketplaceSummary: newEntry,
                                    });
                                  }
                                );
                              }}
                              disabled={this.state.marketplaceSummary.some(
                                (data) => data.id === ''
                              )}
                            >
                              <AddCircleIcon
                                fontSize="small"
                                color="secondary"
                              />
                            </IconButton>
                          </Tooltip>
                        </div>
                      )}
                    </div>
                  )}


                  {this.sectionAllowed('sales') && (
                      <div className="ledger-fixed-table" style={{ marginTop: '-40px', marginBottom: '24px' }}>
                          <TablePage
                            type={'salesLedger'}
                            tableName="Sales"
                            tableColumnHeads={this.getSalesTableHeaders()}
                            tableRows={this.state.salesSummary}
                            tableRow={(row, index, getRowState, setRowState) =>
                              this.getSalesTableRow(
                                row,
                                getRowState,
                                setRowState
                              )
                            }
                            getRowId={(row) => row.id}
                            defaultSortBy={'name'}
                          />

                          {this.state.isEditPayable && (
                            <div style={{ marginTop: '-18px' }}>
                                <div className="divider-ledger" />
                                <Tooltip
                                  title="Add Sales"
                                  style={{ marginLeft: '0px', marginTop: '8px' }}
                                >
                                    <IconButton
                                      onClick={() => {
                                          this.setState(
                                            { listingIdBeingEdited: '' },
                                            () => {
                                                const newEntry = [
                                                    ...this.state.salesSummary,
                                                    {
                                                        id: '',
                                                        name: '',
                                                        totalBalance: '',
                                                    },
                                                ];
                                                this.setState({
                                                    salesSummary: newEntry,
                                                });
                                            }
                                          );
                                      }}
                                      disabled={this.state.salesSummary.some(
                                        (sale) => sale.id === ''
                                      )}
                                    >
                                        <AddCircleIcon
                                          fontSize="small"
                                          color="secondary"
                                        />
                                    </IconButton>
                                </Tooltip>
                            </div>
                          )}
                      </div>
                    )
                  }

                  {this.sectionAllowed('bankAccount') && (
                      <div className="ledger-fixed-table" style={{ marginTop: '-40px', marginBottom: '24px' }}>
                          <TablePage
                            type={'customerLedger'}
                            tableName="BankAccount"
                            tableColumnHeads={this.getBankAccountsTableHeaders()}
                            tableRows={this.state.bankAccountSummary}
                            tableRow={(row, index, getRowState, setRowState) =>
                              this.getBankAccountTableRow(
                                row,
                                getRowState,
                                setRowState
                              )
                            }
                            getRowId={(row) => row.id}
                            defaultSortBy={'name'}
                          />

                          {this.state.isEditPayable && (
                            <div style={{ marginTop: '-18px' }}>
                                <div className="divider-ledger" />
                                <Tooltip
                                  title="Add Bank Account"
                                  style={{ marginLeft: '0px', marginTop: '8px' }}
                                >
                                    <IconButton
                                      onClick={() => {
                                          this.setState(
                                            { listingIdBeingEdited: '' },
                                            () => {
                                                const newEntry = [
                                                    ...this.state.bankAccountSummary,
                                                    {
                                                        id: '',
                                                        name: '',
                                                        totalBalance: '',
                                                    },
                                                ];
                                                this.setState({
                                                    bankAccountSummary: newEntry,
                                                });
                                            }
                                          );
                                      }}
                                      disabled={this.state.bankAccountSummary.some(
                                        (acc) => acc.id === ''
                                      )}
                                    >
                                        <AddCircleIcon
                                          fontSize="small"
                                          color="secondary"
                                        />
                                    </IconButton>
                                </Tooltip>
                            </div>
                          )}
                      </div>
                    )
                  }

                   {this.sectionAllowed('outstandingCheques') && (
                      <div className="ledger-fixed-table" style={{ marginTop: '-40px', marginBottom: '24px' }}>
                          <TablePage
                            type={'customerLedger'}
                            tableName="outstandingChequesSummary"
                            tableColumnHeads={this.getOutstandingChequesTableHeaders()}
                            tableRows={this.state.outstandingChequesSummary}
                            tableRow={(row, index, getRowState, setRowState) =>
                              this.getOutstandingChequesTableRow(
                                row,
                                getRowState,
                                setRowState
                              )
                            }
                            getRowId={(row) => row.id}
                            defaultSortBy={'name'}
                          />

                          {this.state.isEditPayable && (
                            <div style={{ marginTop: '-18px' }}>
                                <div className="divider-ledger" />
                                <Tooltip
                                  title="Add Outstanding Cheque"
                                  style={{ marginLeft: '0px', marginTop: '8px' }}
                                >
                                    <IconButton
                                      onClick={() => {
                                          this.setState(
                                            { listingIdBeingEdited: '' },
                                            () => {
                                                const newEntry = [
                                                    ...this.state.outstandingChequesSummary,
                                                    {
                                                        id: '',
                                                        name: '',
                                                        totalBalance: '',
                                                    },
                                                ];
                                                this.setState({
                                                    outstandingChequesSummary: newEntry,
                                                });
                                            }
                                          );
                                      }}
                                      disabled={this.state.outstandingChequesSummary.some(
                                        (acc) => acc.id === ''
                                      )}
                                    >
                                        <AddCircleIcon
                                          fontSize="small"
                                          color="secondary"
                                        />
                                    </IconButton>
                                </Tooltip>
                            </div>
                          )}
                      </div>
                    )
                  }

                  {this.sectionAllowed('customer') && (
                      <div className="ledger-fixed-table" style={{ marginTop: '-40px', marginBottom: '24px' }}>
                          <TablePage
                            type={'customerLedger'}
                            tableName="Customer"
                            tableColumnHeads={this.getCustomerTableHeaders()}
                            tableRows={this.state.customerSummary}
                            tableRow={(row, index, getRowState, setRowState) =>
                              this.getCustomerTableRow(
                                row,
                                getRowState,
                                setRowState
                              )
                            }
                            getRowId={(row) => row.id}
                            defaultSortBy={'name'}
                          />

                          {this.state.isEditPayable && (
                            <div style={{ marginTop: '-18px' }}>
                                <div className="divider-ledger" />
                                <Tooltip
                                  title="Add Customer"
                                  style={{ marginLeft: '0px', marginTop: '8px' }}
                                >
                                    <IconButton
                                      onClick={() => {
                                          this.setState(
                                            { listingIdBeingEdited: '' },
                                            () => {
                                                const newEntry = [
                                                    ...this.state.customerSummary,
                                                    {
                                                        id: '',
                                                        name: '',
                                                        totalBalance: '',
                                                    },
                                                ];
                                                this.setState({
                                                    customerSummary: newEntry,
                                                });
                                            }
                                          );
                                      }}
                                      disabled={this.state.customerSummary.some(
                                        (customer) => customer.id === ''
                                      )}
                                    >
                                        <AddCircleIcon
                                          fontSize="small"
                                          color="secondary"
                                        />
                                    </IconButton>
                                </Tooltip>
                            </div>
                          )}
                      </div>
                    )
                  }


                {/*{this.props.fetchTransactions?.ledgerEntries &&*/}
                {/*  this.props.fetchTransactions.ledgerEntries.length > 0 && (*/}
                <div className="ledger-other-fixed-table" style={{ marginTop: '-40px', marginBottom: '24px' }}>
                  <TablePage
                    type="LedgerEntriesTable"
                    tableName="LedgerEntriesTable"
                    tableColumnHeads={this.getPayableTableHeaders()}
                    tableRows={this.state.templates}
                    tableRow={(row, index, getRowState, setRowState) =>
                      this.getPayableTableRow(row, getRowState, setRowState)
                    }
                    getRowId={(row) => row.transactionId}
                  />

                  {this.state.isEditPayable && (
                    <Tooltip
                      title="Add Entry"
                      style={{ marginLeft: '0px', marginTop: '8px' }}
                    >
                      <IconButton
                        onClick={() => {
                          this.setState({ listingIdBeingEdited: '' }, () => {
                            const newLedgerEntry = [
                              ...this.state.templates,
                              {
                                transactionId: '',
                                description: '',
                                amount: '',
                              },
                            ];
                            this.setState({ templates: newLedgerEntry });
                          });
                        }}
                        disabled={this.state.templates.some(
                          (template) => template.transactionId === ''
                        )}
                      >
                        <AddCircleIcon fontSize="small" color="secondary" />
                      </IconButton>
                    </Tooltip>
                  )}

                  {this.state.templates &&
                    !this.state.isEditPayable &&
                    Array.isArray(this.state.templates) &&
                    this.state.templates.length > 0 &&
                    this.state.templates.some(
                      (entry) =>
                        entry.description !== 'Cost of Sales' &&
                        entry.description !== 'Accounts Receivables' &&
                        entry.description !== 'Cash' &&
                        entry.description !== 'Accounts Payable' &&
                        entry.description !== 'Sales'
                    ) && (
                      <div style={{ marginLeft: '8px', marginRight: '8px' }}>
                        <TableCell>
                          <IconButton style={{ visibility: 'hidden' }}>
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>

                        <TableCell
                          style={{
                            textAlign: 'right',
                            padding: '5px',
                            paddingRight: '50px',
                            width: '100%',
                            fontWeight: 'bold',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              alignItems: 'center',
                            }}
                          >
                            Total
                          </div>
                        </TableCell>

                        <TableCell
                          style={{
                            textAlign: 'right',
                            padding: '5px',
                            paddingRight: '50px',
                            width: 'auto',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              alignItems: 'center',
                            }}
                          >
                            <span style={{ flexShrink: 0 }}>$</span>
                            <span
                              style={{
                                marginLeft: '55px',
                                minWidth: '80px',
                                textAlign: 'right',
                                fontWeight: 'bold',
                              }}
                            >
                              {this.formatBalance(this.getTotal().otherTotal)}
                            </span>
                          </div>
                        </TableCell>

                        <TableCell>
                          <IconButton style={{ visibility: 'hidden' }}>
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </div>
                    )}

                  {this.state.templates &&
                    !this.state.isEditPayable &&
                    this.state.templates.length > 0 &&
                    this.state.templates.some(
                      (entry) =>
                        entry.description === 'Cost of Sales' ||
                        entry.description === 'Accounts Receivables' ||
                        entry.description === 'Cash' ||
                        entry.description === 'Accounts Payable' ||
                        entry.description === 'Sales'
                    ) && (
                      <div style={{ marginLeft: '8px', marginRight: '8px' }}>
                        <TableCell>
                          <IconButton style={{ visibility: 'hidden' }}>
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>

                        <TableCell
                          style={{
                            textAlign: 'right',
                            padding: '5px',
                            paddingRight: '50px',
                            width: '100%',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              alignItems: 'center',
                              fontWeight: 'bold',
                            }}
                          >
                            {this.props.ledger.name + ' Total'}
                          </div>
                        </TableCell>

                        <TableCell
                          style={{
                            textAlign: 'right',
                            padding: '5px',
                            paddingRight: '50px',
                            width: 'auto',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'flex-start',
                              alignItems: 'center',
                            }}
                          >
                            <span style={{ flexShrink: 0, fontWeight: 'bold' }}>$</span>
                            <span
                              style={{
                                marginLeft: '55px',
                                minWidth: '80px',
                                textAlign: 'right',
                                fontWeight: 'bold',
                              }}
                            >
                              {this.formatBalance(this.getTotal().grandTotal)}
                            </span>
                          </div>
                        </TableCell>

                        <TableCell>
                          <IconButton style={{ visibility: 'hidden' }}>
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </div>
                    )}
                </div>
                {/*)}*/}
              </div>
            )}
          </React.Fragment>
        );
    }
}

export default EditLedger;

